import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { AnonymousClientAuthGuardService as AnonymousClientAuthGuard } from './auth/anonymous-client-guard.service';
import { AnonymousStaffAuthGuardService as AnonymousStaffAuthGuard } from './auth/anonymous-staff-guard.service';
import { StaffAuthGuardService as StaffAuthGuard } from './auth/staff-auth-guard.service';

// From navmenu to link to home page section
////import { BrowserModule } from '@angular/platform-browser';

const routes: Routes = [
  { path: 'jp', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./staff-page/staff-home-page/staff-home.module').then(
        (m) => m.StaffHomeModule
      ),
    // loadChildren:
    //   './staff-page/staff-home-page/staff-home.module#StaffHomeModule'
  },
  { path: 'en/', redirectTo: 'en', pathMatch: 'full' },
  {
    path: 'en',
    loadChildren: () =>
      import('./staff-page/staff-home-page/staff-home.module').then(
        (m) => m.StaffHomeModule
      ),
    // loadChildren:
    //   './staff-page/staff-home-page/staff-home.module#StaffHomeModule'
  },
  { path: 'kr/', redirectTo: 'kr', pathMatch: 'full' },
  {
    path: 'kr',
    loadChildren: () =>
      import('./staff-page/staff-home-page/staff-home.module').then(
        (m) => m.StaffHomeModule
      ),
    // loadChildren:
    //   './staff-page/staff-home-page/staff-home.module#StaffHomeModule'
  },
  { path: 'cn/', redirectTo: 'cn', pathMatch: 'full' },
  {
    path: 'cn',
    loadChildren: () =>
      import('./staff-page/staff-home-page/staff-home.module').then(
        (m) => m.StaffHomeModule
      ),
    // loadChildren:
    //   './staff-page/staff-home-page/staff-home.module#StaffHomeModule'
  },
  { path: 'jp/client', redirectTo: 'client', pathMatch: 'full' },
  {
    path: 'client',
    loadChildren: () =>
      import('./company-page/company-home-page/company-home.module').then(
        (m) => m.CompanyHomeModule
      ),
  },
  {
    path: 'en/client',
    loadChildren: () =>
      import('./company-page/company-home-page/company-home.module').then(
        (m) => m.CompanyHomeModule
      ),
  },
  {
    path: 'my-page',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-my-page/staff-my-page.module').then(
        (m) => m.StaffMyPageModule
      ),
  },
  {
    path: 'en/my-page',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-my-page/staff-my-page.module').then(
        (m) => m.StaffMyPageModule
      ),
  },
  {
    path: 'kr/my-page',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-my-page/staff-my-page.module').then(
        (m) => m.StaffMyPageModule
      ),
  },
  {
    path: 'cn/my-page',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-my-page/staff-my-page.module').then(
        (m) => m.StaffMyPageModule
      ),
  },
   {
     path: 'client/resume-detail/:StaffNo/:JobCode',
     loadChildren: () =>
       import(
         './company-page/company-resume-detail/company-resume-detail.module'
       ).then((m) => m.CompanyResumeDetailModule),
   },
   {
     path: 'en/client/resume-detail/:StaffNo',
     loadChildren: () =>
       import('./company-page/company-resume-detail/company-resume-detail.module').then(
         (m) => m.CompanyResumeDetailModule
       ),
   },
    {
      path: 'client/resume-detail/:StaffNo',
      loadChildren: () =>
        import(
          './company-page/company-resume-detail/company-resume-detail.module'
        ).then((m) => m.CompanyResumeDetailModule),
    },
    {
      path: 'en/client/resume-detail/:StaffNo',
      canActivate: [AnonymousStaffAuthGuard],
      loadChildren: () =>
        import(
          './company-page/company-resume-detail/company-resume-detail.module'
        ).then((m) => m.CompanyResumeDetailModule),
    },

  {
    path: 'review-resume',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-review-resume/staff-review-resume.module'
      ).then((m) => m.StaffReviewOfResumeModule),
  },
  {
    path: 'en/review-resume',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-review-resume/staff-review-resume.module'
      ).then((m) => m.StaffReviewOfResumeModule),
  },
  {
    path: 'kr/review-resume',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-review-resume/staff-review-resume.module'
      ).then((m) => m.StaffReviewOfResumeModule),
  },
  {
    path: 'cn/review-resume',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-review-resume/staff-review-resume.module'
      ).then((m) => m.StaffReviewOfResumeModule),
  },
  {
    path: 'register-bank',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-register-bank/staff-register-bank.module'
      ).then((m) => m.StaffRegisterBankModule),
  },
  {
    path: 'en/register-bank',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-register-bank/staff-register-bank.module'
      ).then((m) => m.StaffRegisterBankModule),
  },
  {
    path: 'kr/register-bank',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-register-bank/staff-register-bank.module'
      ).then((m) => m.StaffRegisterBankModule),
  },
  {
    path: 'cn/register-bank',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-register-bank/staff-register-bank.module'
      ).then((m) => m.StaffRegisterBankModule),
  },
  {
    path: 'registration-info',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-info/staff-registration-info.module'
      ).then((m) => m.StaffRegistrationInfoModule),
  },
  {
    path: 'en/registration-info',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-info/staff-registration-info.module'
      ).then((m) => m.StaffRegistrationInfoModule),
  },
  {
    path: 'kr/registration-info',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-info/staff-registration-info.module'
      ).then((m) => m.StaffRegistrationInfoModule),
  },
  {
    path: 'registration',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-page/staff-registration-page.module'
      ).then((m) => m.StaffRegistrationPageModule),
  },
  {
    path: 'en/registration',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-page/staff-registration-page.module'
      ).then((m) => m.StaffRegistrationPageModule),
  },
  {
    path: 'kr/registration',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-page/staff-registration-page.module'
      ).then((m) => m.StaffRegistrationPageModule),
  },
  {
    path: 'cn/registration',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-page/staff-registration-page.module'
      ).then((m) => m.StaffRegistrationPageModule),
  },
  {
    path: 'registration-preview',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-preview/staff-registration-preview.module'
      ).then((m) => m.StaffRegistrationPreviewModule),
  },
  {
    path: 'en/registration-preview',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-preview/staff-registration-preview.module'
      ).then((m) => m.StaffRegistrationPreviewModule),
  },
  {
    path: 'kr/registration-preview',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-preview/staff-registration-preview.module'
      ).then((m) => m.StaffRegistrationPreviewModule),
  },
  {
    path: 'cn/registration-preview',
    canActivate: [AnonymousStaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-preview/staff-registration-preview.module'
      ).then((m) => m.StaffRegistrationPreviewModule),
  },
  {
    path: 'verify-email-for-staff-registration/:code/:staffId',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-email-verify/staff-registration-email-verify.module'
      ).then((m) => m.StaffRegistrationEmailVerifyModule),
  },
  { 
    path: 'verify-email-for-staff-registration/:code/:staffId',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-email-verify/staff-registration-email-verify.module'
      ).then((m) => m.StaffRegistrationEmailVerifyModule),
  },
  {
    path: 'en/verify-email-for-staff-registration/:code/:staffId',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-email-verify/staff-registration-email-verify.module'
      ).then((m) => m.StaffRegistrationEmailVerifyModule),
  },
  {
    path: 'kr/verify-email-for-staff-registration/:code/:staffId',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-email-verify/staff-registration-email-verify.module'
      ).then((m) => m.StaffRegistrationEmailVerifyModule),
  },
  {
    path: 'cn/verify-email-for-staff-registration/:code/:staffId',
    loadChildren: () =>
      import(
        './staff-page/staff-registration-email-verify/staff-registration-email-verify.module'
      ).then((m) => m.StaffRegistrationEmailVerifyModule),
  },
  {
    path: 'registration-basic-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-basic-info/staff-basic-info.module').then(
        (m) => m.StaffBasicInfoModule
      ),
  },
  {
    path: 'en/registration-basic-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-basic-info/staff-basic-info.module').then(
        (m) => m.StaffBasicInfoModule
      ),
  },
  {
    path: 'kr/registration-basic-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-basic-info/staff-basic-info.module').then(
        (m) => m.StaffBasicInfoModule
      ),
  },
  {
    path: 'cn/registration-basic-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-basic-info/staff-basic-info.module').then(
        (m) => m.StaffBasicInfoModule
      ),
  },
  {
    path: 'registration-basic-info-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-basic-info-preview/staff-basic-info-preview.module'
      ).then((m) => m.StaffBasicInfoPreviewModule),
  },
  {
    path: 'en/registration-basic-info-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-basic-info-preview/staff-basic-info-preview.module'
      ).then((m) => m.StaffBasicInfoPreviewModule),
  },
  {
    path: 'kr/registration-basic-info-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-basic-info-preview/staff-basic-info-preview.module'
      ).then((m) => m.StaffBasicInfoPreviewModule),
  },
  {
    path: 'cn/registration-basic-info-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-basic-info-preview/staff-basic-info-preview.module'
      ).then((m) => m.StaffBasicInfoPreviewModule),
  },
  {
    path: 'registration-education-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history/staff-education-history.module'
      ).then((m) => m.StaffEducationHistoryModule),
  },
  {
    path: 'en/registration-education-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history/staff-education-history.module'
      ).then((m) => m.StaffEducationHistoryModule),
  },
  {
    path: 'kr/registration-education-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history/staff-education-history.module'
      ).then((m) => m.StaffEducationHistoryModule),
  },
  {
    path: 'cn/registration-education-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history/staff-education-history.module'
      ).then((m) => m.StaffEducationHistoryModule),
  },
  {
    path: 'registration-education-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history-preview/staff-education-history-preview.module'
      ).then((m) => m.StaffEducationHistoryPreviewModule),
  },
  {
    path: 'en/registration-education-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history-preview/staff-education-history-preview.module'
      ).then((m) => m.StaffEducationHistoryPreviewModule),
  },
  {
    path: 'kr/registration-education-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history-preview/staff-education-history-preview.module'
      ).then((m) => m.StaffEducationHistoryPreviewModule),
  },
  {
    path: 'cn/registration-education-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-education-history-preview/staff-education-history-preview.module'
      ).then((m) => m.StaffEducationHistoryPreviewModule),
  },
  {
    path: 'registration-job-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-job-history/staff-job-history.module').then(
        (m) => m.StaffJobHistoryModule
      ),
  },
  {
    path: 'en/registration-job-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-job-history/staff-job-history.module').then(
        (m) => m.StaffJobHistoryModule
      ),
  },
  {
    path: 'kr/registration-job-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-job-history/staff-job-history.module').then(
        (m) => m.StaffJobHistoryModule
      ),
  },
  {
    path: 'cn/registration-job-history',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-job-history/staff-job-history.module').then(
        (m) => m.StaffJobHistoryModule
      ),
  },
  {
    path: 'registration-job-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-preview/staff-job-history-preview.module'
      ).then((m) => m.StaffJobHistoryPreviewModule),
  },
  {
    path: 'en/registration-job-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-preview/staff-job-history-preview.module'
      ).then((m) => m.StaffJobHistoryPreviewModule),
  },
  {
    path: 'kr/registration-job-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-preview/staff-job-history-preview.module'
      ).then((m) => m.StaffJobHistoryPreviewModule),
  },
  {
    path: 'cn/registration-job-history-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-preview/staff-job-history-preview.module'
      ).then((m) => m.StaffJobHistoryPreviewModule),
  },
  {
    path: 'registration-skills',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills/staff-registration-skills.module'
      ).then((m) => m.StaffRegistrationSkillsModule),
  },
  {
    path: 'en/registration-skills',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills/staff-registration-skills.module'
      ).then((m) => m.StaffRegistrationSkillsModule),
  },
  {
    path: 'kr/registration-skills',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills/staff-registration-skills.module'
      ).then((m) => m.StaffRegistrationSkillsModule),
  },
  {
    path: 'cn/registration-skills',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills/staff-registration-skills.module'
      ).then((m) => m.StaffRegistrationSkillsModule),
  },
  {
    path: 'registration-skills-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills-preview/staff-registration-skills-preview.module'
      ).then((m) => m.StaffRegistrationSkillsPreviewModule),
  },
  {
    path: 'en/registration-skills-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills-preview/staff-registration-skills-preview.module'
      ).then((m) => m.StaffRegistrationSkillsPreviewModule),
  },
  {
    path: 'kr/registration-skills-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills-preview/staff-registration-skills-preview.module'
      ).then((m) => m.StaffRegistrationSkillsPreviewModule),
  },
  {
    path: 'cn/registration-skills-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-skills-preview/staff-registration-skills-preview.module'
      ).then((m) => m.StaffRegistrationSkillsPreviewModule),
  },
  {
    path: 'registration-translation-interpretation',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation/staff-registration-translation-interpretation.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationModule),
  },
  {
    path: 'mail-setting/:id',
    loadChildren: () =>
      import(
        './staff-page/staff-email-setting/staff-email-setting.module'
      ).then((m) => m.StaffEmailSettingModule),
  },
  {
    path: 'en/mail-setting/:id',
    loadChildren: () =>
      import(
        './staff-page/staff-email-setting/staff-email-setting.module'
      ).then((m) => m.StaffEmailSettingModule),
  },

  {
    path: 'kr/mail-setting/:id',
    loadChildren: () =>
      import(
        './staff-page/staff-email-setting/staff-email-setting.module'
      ).then((m) => m.StaffEmailSettingModule),
  },
  {
    path: 'cn/mail-setting/:id',
    loadChildren: () =>
      import(
        './staff-page/staff-email-setting/staff-email-setting.module'
      ).then((m) => m.StaffEmailSettingModule),
  },

  {
    path: 'en/registration-translation-interpretation',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation/staff-registration-translation-interpretation.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationModule),
  },
  {
    path: 'kr/registration-translation-interpretation',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation/staff-registration-translation-interpretation.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationModule),
  },
  {
    path: 'cn/registration-translation-interpretation',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation/staff-registration-translation-interpretation.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationModule),
  },
  {
    path: 'registration-translation-interpretation-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation-preview/staff-registration-translation-interpretation-preview.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationPreviewModule),
  },
  {
    path: 'en/registration-translation-interpretation-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation-preview/staff-registration-translation-interpretation-preview.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationPreviewModule),
  },
  {
    path: 'kr/registration-translation-interpretation-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation-preview/staff-registration-translation-interpretation-preview.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationPreviewModule),
  },
  {
    path: 'cn/registration-translation-interpretation-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-translation-interpretation-preview/staff-registration-translation-interpretation-preview.module'
      ).then((m) => m.StaffRegistrationTranslationInterpretationPreviewModule),
  },
  {
    path: 'registration-narrator',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator/staff-registration-narrator.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'en/registration-narrator',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator/staff-registration-narrator.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'kr/registration-narrator',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator/staff-registration-narrator.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'cn/registration-narrator',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator/staff-registration-narrator.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'registration-narrator-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator-preview/staff-registration-narrator-preview.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'en/registration-narrator-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator-preview/staff-registration-narrator-preview.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'kr/registration-narrator-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator-preview/staff-registration-narrator-preview.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'cn/registration-narrator-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-narrator-preview/staff-registration-narrator-preview.module'
      ).then((m) => m.StaffRegistrationNarratorModule),
  },
  {
    path: 'registration-photo',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-photo/staff-registration-photo.module'
      ).then((m) => m.StaffRegistrationPhotoModule),
  },
  {
    path: 'en/registration-photo',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-photo/staff-registration-photo.module'
      ).then((m) => m.StaffRegistrationPhotoModule),
  },
  {
    path: 'kr/registration-photo',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-photo/staff-registration-photo.module'
      ).then((m) => m.StaffRegistrationPhotoModule),
  },
  {
    path: 'cn/registration-photo',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-photo/staff-registration-photo.module'
      ).then((m) => m.StaffRegistrationPhotoModule),
  },
  {
    path: 'registration-status',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-status/staff-registration-status.module'
      ).then((m) => m.StaffRegistrationStatusModule),
  },
  {
    path: 'en/registration-status',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-status/staff-registration-status.module'
      ).then((m) => m.StaffRegistrationStatusModule),
  },
  {
    path: 'kr/registration-status',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-status/staff-registration-status.module'
      ).then((m) => m.StaffRegistrationStatusModule),
  },
  {
    path: 'cn/registration-status',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-registration-status/staff-registration-status.module'
      ).then((m) => m.StaffRegistrationStatusModule),
  },
  {
    path: 'company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
  {
    path: 'en/company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
  {
    path: 'kr/company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
  {
    path: 'staff-payment-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-payment/staff-payment.module').then(
        (m) => m.StaffPaymentModule
      ),
  },
  {
    path: 'en/staff-payment-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-payment/staff-payment.module').then(
        (m) => m.StaffPaymentModule
      ),
  },
  {
    path: 'kr/staff-payment-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-payment/staff-payment.module').then(
        (m) => m.StaffPaymentModule
      ),
  },
  {
    path: 'cn/staff-payment-info',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-payment/staff-payment.module').then(
        (m) => m.StaffPaymentModule
      ),
  },
  {
    path: 'self-promotion',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion/staff-self-promotion.module'
      ).then((m) => m.StaffSelfPromotionModule),
  },
  {
    path: 'en/self-promotion',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion/staff-self-promotion.module'
      ).then((m) => m.StaffSelfPromotionModule),
  },
  {
    path: 'kr/self-promotion',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion/staff-self-promotion.module'
      ).then((m) => m.StaffSelfPromotionModule),
  },
  {
    path: 'cn/self-promotion',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion/staff-self-promotion.module'
      ).then((m) => m.StaffSelfPromotionModule),
  },
  {
    path: 'self-promotion-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion-preview/staff-self-promotion-preview.module'
      ).then((m) => m.StaffSelfPromotionPreviewModule),
  },
  {
    path: 'en/self-promotion-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion-preview/staff-self-promotion-preview.module'
      ).then((m) => m.StaffSelfPromotionPreviewModule),
  },
  {
    path: 'kr/self-promotion-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion-preview/staff-self-promotion-preview.module'
      ).then((m) => m.StaffSelfPromotionPreviewModule),
  },
  {
    path: 'cn/self-promotion-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-self-promotion-preview/staff-self-promotion-preview.module'
      ).then((m) => m.StaffSelfPromotionPreviewModule),
  },
  {
    path: 'jp/staff-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './staff-page/staff-forgot-password/staff-forgot-password.module'
      ).then((m) => m.StaffForgotPasswordModule),
  },
  {
    path: 'staff-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './staff-page/staff-forgot-password/staff-forgot-password.module'
      ).then((m) => m.StaffForgotPasswordModule),
  },

  {
    path: 'en/staff-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './staff-page/staff-forgot-password/staff-forgot-password.module'
      ).then((m) => m.StaffForgotPasswordModule),
  },
  {
    path: 'job-search',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'en/job-search',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'kr/job-search',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'cn/job-search',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'job-search/:id/:type',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'en/job-search/:id/:type',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'kr/job-search/:id/:type',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'cn/job-search/:id/:type',
    loadChildren: () =>
      import('./staff-page/staff-job-search/staff-job-search.module').then(
        (m) => m.StaffJobSearchModule
      ),
  },
  {
    path: 'job-detail/:jobCode',
    loadChildren: () =>
      import('./staff-page/staff-job-detail/staff-job-detail.module').then(
        (m) => m.StaffJobDetailModule
      ),
  },
  {
    path: 'en/job-detail/:jobCode',
    loadChildren: () =>
      import('./staff-page/staff-job-detail/staff-job-detail.module').then(
        (m) => m.StaffJobDetailModule
      ),
  },
  {
    path: 'kr/job-detail/:jobCode',
    loadChildren: () =>
      import('./staff-page/staff-job-detail/staff-job-detail.module').then(
        (m) => m.StaffJobDetailModule
      ),
  },
  {
    path: 'cn/job-detail/:jobCode',
    loadChildren: () =>
      import('./staff-page/staff-job-detail/staff-job-detail.module').then(
        (m) => m.StaffJobDetailModule
      ),
  },
  {
    path: 'company-detail/:registrationId/:isSubCompany',
    loadChildren: () =>
      import(
        './staff-page/staff-company-detail/staff-company-detail.module'
      ).then((m) => m.StaffCompanyDetailModule),
  },
  {
    path: 'en/company-detail/:registrationId/:isSubCompany',
    loadChildren: () =>
      import(
        './staff-page/staff-company-detail/staff-company-detail.module'
      ).then((m) => m.StaffCompanyDetailModule),
  },
  {
    path: 'kr/company-detail/:registrationId/:isSubCompany',
    loadChildren: () =>
      import(
        './staff-page/staff-company-detail/staff-company-detail.module'
      ).then((m) => m.StaffCompanyDetailModule),
  },
  {
    path: 'cn/company-detail/:registrationId/:isSubCompany',
    loadChildren: () =>
      import(
        './staff-page/staff-company-detail/staff-company-detail.module'
      ).then((m) => m.StaffCompanyDetailModule),
  },
  {
    path: 'apply-job/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-application/staff-application.module').then(
        (m) => m.StaffApplicationModule
      ),
  },
  {
    path: 'en/apply-job/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-application/staff-application.module').then(
        (m) => m.StaffApplicationModule
      ),
  },
  {
    path: 'kr/apply-job/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-application/staff-application.module').then(
        (m) => m.StaffApplicationModule
      ),
  },
  {
    path: 'cn/apply-job/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-application/staff-application.module').then(
        (m) => m.StaffApplicationModule
      ),
  },
  {
    path: 'apply-job-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-application-preview/staff-application-preview.module'
      ).then((m) => m.StaffApplicationPreviewModule),
  },
  {
    path: 'en/apply-job-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-application-preview/staff-application-preview.module'
      ).then((m) => m.StaffApplicationPreviewModule),
  },
  {
    path: 'kr/apply-job-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-application-preview/staff-application-preview.module'
      ).then((m) => m.StaffApplicationPreviewModule),
  },
  {
    path: 'cn/apply-job-preview',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-application-preview/staff-application-preview.module'
      ).then((m) => m.StaffApplicationPreviewModule),
  },
  {
    path: 'favourite-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-favorites-list/staff-favorites-list.module'
      ).then((m) => m.StaffFavoritesListModule),
  },
  {
    path: 'en/favourite-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-favorites-list/staff-favorites-list.module'
      ).then((m) => m.StaffFavoritesListModule),
  },
  {
    path: 'kr/favourite-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-favorites-list/staff-favorites-list.module'
      ).then((m) => m.StaffFavoritesListModule),
  },
  {
    path: 'cn/favourite-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-favorites-list/staff-favorites-list.module'
      ).then((m) => m.StaffFavoritesListModule),
  },
  {
    path: 'applied-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-applied-job-list/staff-applied-job-list.module'
      ).then((m) => m.StaffAppliedJobListModule),
  },
  {
    path: 'en/applied-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-applied-job-list/staff-applied-job-list.module'
      ).then((m) => m.StaffAppliedJobListModule),
  },
  {
    path: 'kr/applied-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-applied-job-list/staff-applied-job-list.module'
      ).then((m) => m.StaffAppliedJobListModule),
  },
  {
    path: 'cn/applied-job-list',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-applied-job-list/staff-applied-job-list.module'
      ).then((m) => m.StaffAppliedJobListModule),
  },
  {
    path: 'content/02manner',
    loadChildren: () =>
      import(
        './staff-page/staff-business-etiqutte-in-jp/staff-business-etiqutte-in-jp.module'
      ).then((m) => m.StaffBusinessEtiqutteInJpModule),
  },
  {
    path: 'en/content/02manner',
    loadChildren: () =>
      import(
        './staff-page/staff-business-etiqutte-in-jp/staff-business-etiqutte-in-jp.module'
      ).then((m) => m.StaffBusinessEtiqutteInJpModule),
  },
  {
    path: 'kr/content/02manner',
    loadChildren: () =>
      import(
        './staff-page/staff-business-etiqutte-in-jp/staff-business-etiqutte-in-jp.module'
      ).then((m) => m.StaffBusinessEtiqutteInJpModule),
  },
  {
    path: 'cn/content/02manner',
    loadChildren: () =>
      import(
        './staff-page/staff-business-etiqutte-in-jp/staff-business-etiqutte-in-jp.module'
      ).then((m) => m.StaffBusinessEtiqutteInJpModule),
  },
  {
    path: 'content/jobtype',
    loadChildren: () =>
      import(
        './staff-page/staff-diff-reg-emp-and-temp-emp/staff-diff-reg-emp-and-temp-emp.module'
      ).then((m) => m.StaffDiffRegAndTempEmpModule),
  },
  {
    path: 'en/content/jobtype',
    loadChildren: () =>
      import(
        './staff-page/staff-diff-reg-emp-and-temp-emp/staff-diff-reg-emp-and-temp-emp.module'
      ).then((m) => m.StaffDiffRegAndTempEmpModule),
  },
  {
    path: 'kr/content/jobtype',
    loadChildren: () =>
      import(
        './staff-page/staff-diff-reg-emp-and-temp-emp/staff-diff-reg-emp-and-temp-emp.module'
      ).then((m) => m.StaffDiffRegAndTempEmpModule),
  },
  {
    path: 'cn/content/jobtype',
    loadChildren: () =>
      import(
        './staff-page/staff-diff-reg-emp-and-temp-emp/staff-diff-reg-emp-and-temp-emp.module'
      ).then((m) => m.StaffDiffRegAndTempEmpModule),
  },
  {
    path: 'content/03businessjpn',
    loadChildren: () =>
      import(
        './staff-page/staff-frequent-japanese-word/staff-frequent-japanese-word.module'
      ).then((m) => m.StaffFequentJapaneseWordModule),
  },
  {
    path: 'en/content/03businessjpn',
    loadChildren: () =>
      import(
        './staff-page/staff-frequent-japanese-word/staff-frequent-japanese-word.module'
      ).then((m) => m.StaffFequentJapaneseWordModule),
  },
  {
    path: 'kr/content/03businessjpn',
    loadChildren: () =>
      import(
        './staff-page/staff-frequent-japanese-word/staff-frequent-japanese-word.module'
      ).then((m) => m.StaffFequentJapaneseWordModule),
  },
  {
    path: 'cn/content/03businessjpn',
    loadChildren: () =>
      import(
        './staff-page/staff-frequent-japanese-word/staff-frequent-japanese-word.module'
      ).then((m) => m.StaffFequentJapaneseWordModule),
  },
  {
    path: 'how-to-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-interview-in-japan/staff-how-to-interview-in-japan.module'
      ).then((m) => m.StaffHowToInterviewInJapanModule),
  },
  {
    path: 'en/how-to-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-interview-in-japan/staff-how-to-interview-in-japan.module'
      ).then((m) => m.StaffHowToInterviewInJapanModule),
  },
  {
    path: 'kr/how-to-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-interview-in-japan/staff-how-to-interview-in-japan.module'
      ).then((m) => m.StaffHowToInterviewInJapanModule),
  },
  {
    path: 'cn/how-to-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-interview-in-japan/staff-how-to-interview-in-japan.module'
      ).then((m) => m.StaffHowToInterviewInJapanModule),
  },
  {
    path: 'use-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-use-hiwork/staff-how-to-use-hiwork.module'
      ).then((m) => m.StaffHowToUseHiworkModule),
  },
  {
    path: 'en/use-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-use-hiwork/staff-how-to-use-hiwork.module'
      ).then((m) => m.StaffHowToUseHiworkModule),
  },
  {
    path: 'kr/use-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-use-hiwork/staff-how-to-use-hiwork.module'
      ).then((m) => m.StaffHowToUseHiworkModule),
  },
  {
    path: 'cn/use-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-use-hiwork/staff-how-to-use-hiwork.module'
      ).then((m) => m.StaffHowToUseHiworkModule),
  },
  {
    path: 'how-to-find-a-job-in-japan',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-work-in-japan/staff-how-to-work-in-japan.module'
      ).then((m) => m.StaffHowToWorkInJapanModule),
  },
  {
    path: 'en/how-to-find-a-job-in-japan',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-work-in-japan/staff-how-to-work-in-japan.module'
      ).then((m) => m.StaffHowToWorkInJapanModule),
  },
  {
    path: 'kr/how-to-find-a-job-in-japan',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-work-in-japan/staff-how-to-work-in-japan.module'
      ).then((m) => m.StaffHowToWorkInJapanModule),
  },
  {
    path: 'cn/how-to-find-a-job-in-japan',
    loadChildren: () =>
      import(
        './staff-page/staff-how-to-work-in-japan/staff-how-to-work-in-japan.module'
      ).then((m) => m.StaffHowToWorkInJapanModule),
  },
  {
    path: 'content/01life',
    loadChildren: () =>
      import(
        './staff-page/staff-info-about-life-in-japan/staff-info-about-life-in-japan.module'
      ).then((m) => m.StaffInfoAboutLifeInJapanModule),
  },
  {
    path: 'en/content/01life',
    loadChildren: () =>
      import(
        './staff-page/staff-info-about-life-in-japan/staff-info-about-life-in-japan.module'
      ).then((m) => m.StaffInfoAboutLifeInJapanModule),
  },
  {
    path: 'kr/content/01life',
    loadChildren: () =>
      import(
        './staff-page/staff-info-about-life-in-japan/staff-info-about-life-in-japan.module'
      ).then((m) => m.StaffInfoAboutLifeInJapanModule),
  },
  {
    path: 'cn/content/01life',
    loadChildren: () =>
      import(
        './staff-page/staff-info-about-life-in-japan/staff-info-about-life-in-japan.module'
      ).then((m) => m.StaffInfoAboutLifeInJapanModule),
  },
  {
    path: 'content/01interview',
    loadChildren: () =>
      import(
        './staff-page/staff-interview-or-meeting-in-jp/staff-interview-or-meeting-in-jp.module'
      ).then((m) => m.StaffInterviewOrMeetingInJpModule),
  },
  {
    path: 'en/content/01interview',
    loadChildren: () =>
      import(
        './staff-page/staff-interview-or-meeting-in-jp/staff-interview-or-meeting-in-jp.module'
      ).then((m) => m.StaffInterviewOrMeetingInJpModule),
  },
  {
    path: 'kr/content/01interview',
    loadChildren: () =>
      import(
        './staff-page/staff-interview-or-meeting-in-jp/staff-interview-or-meeting-in-jp.module'
      ).then((m) => m.StaffInterviewOrMeetingInJpModule),
  },
  {
    path: 'cn/content/01interview',
    loadChildren: () =>
      import(
        './staff-page/staff-interview-or-meeting-in-jp/staff-interview-or-meeting-in-jp.module'
      ).then((m) => m.StaffInterviewOrMeetingInJpModule),
  },
  {
    path: 'content/findjob',
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-in-japan/staff-job-history-in-japan.module'
      ).then((m) => m.StaffJobHistoryInJapanModule),
  },
  {
    path: 'en/content/findjob',
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-in-japan/staff-job-history-in-japan.module'
      ).then((m) => m.StaffJobHistoryInJapanModule),
  },
  {
    path: 'kr/content/findjob',
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-in-japan/staff-job-history-in-japan.module'
      ).then((m) => m.StaffJobHistoryInJapanModule),
  },
  {
    path: 'cn/content/findjob',
    loadChildren: () =>
      import(
        './staff-page/staff-job-history-in-japan/staff-job-history-in-japan.module'
      ).then((m) => m.StaffJobHistoryInJapanModule),
  },
  {
    path: 'content/manner',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-custom-for-job-applicants/staff-jp-custom-for-job-applicants.module'
      ).then((m) => m.StaffJpCustomForJobApplicantsModule),
  },
  {
    path: 'en/content/manner',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-custom-for-job-applicants/staff-jp-custom-for-job-applicants.module'
      ).then((m) => m.StaffJpCustomForJobApplicantsModule),
  },
  {
    path: 'kr/content/manner',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-custom-for-job-applicants/staff-jp-custom-for-job-applicants.module'
      ).then((m) => m.StaffJpCustomForJobApplicantsModule),
  },
  {
    path: 'cn/content/manner',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-custom-for-job-applicants/staff-jp-custom-for-job-applicants.module'
      ).then((m) => m.StaffJpCustomForJobApplicantsModule),
  },
  {
    path: 'faq-at-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-FAQ-interview/staff-jp-FAQ-interview.module'
      ).then((m) => m.StaffJpFAQInterviewModule),
  },
  {
    path: 'en/faq-at-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-FAQ-interview/staff-jp-FAQ-interview.module'
      ).then((m) => m.StaffJpFAQInterviewModule),
  },
  {
    path: 'kr/faq-at-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-FAQ-interview/staff-jp-FAQ-interview.module'
      ).then((m) => m.StaffJpFAQInterviewModule),
  },
  {
    path: 'cn/faq-at-interview',
    loadChildren: () =>
      import(
        './staff-page/staff-jp-FAQ-interview/staff-jp-FAQ-interview.module'
      ).then((m) => m.StaffJpFAQInterviewModule),
  },
  {
    path: 'content/02interview',
    loadChildren: () =>
      import(
        './staff-page/staff-precautions-invt-for-jp/staff-precautions-invt-for-jp.module'
      ).then((m) => m.StaffPrecautionsInvtForJpModule),
  },
  {
    path: 'en/content/02interview',
    loadChildren: () =>
      import(
        './staff-page/staff-precautions-invt-for-jp/staff-precautions-invt-for-jp.module'
      ).then((m) => m.StaffPrecautionsInvtForJpModule),
  },
  {
    path: 'kr/content/02interview',
    loadChildren: () =>
      import(
        './staff-page/staff-precautions-invt-for-jp/staff-precautions-invt-for-jp.module'
      ).then((m) => m.StaffPrecautionsInvtForJpModule),
  },
  {
    path: 'cn/content/02interview',
    loadChildren: () =>
      import(
        './staff-page/staff-precautions-invt-for-jp/staff-precautions-invt-for-jp.module'
      ).then((m) => m.StaffPrecautionsInvtForJpModule),
  },
  {
    path: 'content/03interview',
    loadChildren: () =>
      import('./staff-page/interview-proceed/interview-proceed.module').then(
        (m) => m.InterviewProceedModule
      ),
  },
  {
    path: 'en/content/03interview',
    loadChildren: () =>
      import('./staff-page/interview-proceed/interview-proceed.module').then(
        (m) => m.InterviewProceedModule
      ),
  },
  {
    path: 'content/04interview',
    loadChildren: () =>
      import(
        './staff-page/jp-phrase-use-interview/jp-phrase-use-interview.module'
      ).then((m) => m.JpPhraseUseInterviewModule),
  },
  {
    path: 'en/content/04interview',
    loadChildren: () =>
      import(
        './staff-page/jp-phrase-use-interview/jp-phrase-use-interview.module'
      ).then((m) => m.JpPhraseUseInterviewModule),
  },
  {
    path: 'social-insurance',
    loadChildren: () =>
      import(
        './staff-page/staff-social-insurance/staff-social-insurance.module'
      ).then((m) => m.StaffSocialInsuranceModule),
  },
  {
    path: 'en/social-insurance',
    loadChildren: () =>
      import(
        './staff-page/staff-social-insurance/staff-social-insurance.module'
      ).then((m) => m.StaffSocialInsuranceModule),
  },
  {
    path: 'kr/social-insurance',
    loadChildren: () =>
      import(
        './staff-page/staff-social-insurance/staff-social-insurance.module'
      ).then((m) => m.StaffSocialInsuranceModule),
  },
  {
    path: 'cn/social-insurance',
    loadChildren: () =>
      import(
        './staff-page/staff-social-insurance/staff-social-insurance.module'
      ).then((m) => m.StaffSocialInsuranceModule),
  },
  {
    path: 'content/advice',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume/staff-write-a-resume.module'
      ).then((m) => m.StaffWriteAresumeModule),
  },
  {
    path: 'en/content/advice',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume/staff-write-a-resume.module'
      ).then((m) => m.StaffWriteAresumeModule),
  },
  {
    path: 'kr/content/advice',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume/staff-write-a-resume.module'
      ).then((m) => m.StaffWriteAresumeModule),
  },
  {
    path: 'cn/content/advice',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume/staff-write-a-resume.module'
      ).then((m) => m.StaffWriteAresumeModule),
  },
  {
    path: 'content/resume',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume-for-jp/staff-write-a-resume-for-jp.module'
      ).then((m) => m.StaffWriteAresumeForJpModule),
  },
  {
    path: 'en/content/resume',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume-for-jp/staff-write-a-resume-for-jp.module'
      ).then((m) => m.StaffWriteAresumeForJpModule),
  },
  {
    path: 'kr/content/resume',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume-for-jp/staff-write-a-resume-for-jp.module'
      ).then((m) => m.StaffWriteAresumeForJpModule),
  },
  {
    path: 'cn/content/resume',
    loadChildren: () =>
      import(
        './staff-page/staff-write-a-resume-for-jp/staff-write-a-resume-for-jp.module'
      ).then((m) => m.StaffWriteAresumeForJpModule),
  },
  {
    path: 'content/04advice',
    loadChildren: () =>
      import(
        './staff-page/staff-posted-experiences-of-staff/staff-posted-experiences-of-staff.module'
      ).then((m) => m.SStaffPostedExperiencesOfStaffModule),
  },
  {
    path: 'en/content/04advice',
    loadChildren: () =>
      import(
        './staff-page/staff-posted-experiences-of-staff/staff-posted-experiences-of-staff.module'
      ).then((m) => m.SStaffPostedExperiencesOfStaffModule),
  },
  {
    path: 'kr/content/04advice',
    loadChildren: () =>
      import(
        './staff-page/staff-posted-experiences-of-staff/staff-posted-experiences-of-staff.module'
      ).then((m) => m.SStaffPostedExperiencesOfStaffModule),
  },
  {
    path: 'cn/content/04advice',
    loadChildren: () =>
      import(
        './staff-page/staff-posted-experiences-of-staff/staff-posted-experiences-of-staff.module'
      ).then((m) => m.SStaffPostedExperiencesOfStaffModule),
  },
  {
    path: 'content/05faq',
    loadChildren: () =>
      import(
        './staff-page/staff-faq-for-employment-in-japan/staff-faq-for-employment-in-japan.module'
      ).then((m) => m.StaffFaqForEmploymentInJapanModule),
  },
  {
    path: 'en/content/05faq',
    loadChildren: () =>
      import(
        './staff-page/staff-faq-for-employment-in-japan/staff-faq-for-employment-in-japan.module'
      ).then((m) => m.StaffFaqForEmploymentInJapanModule),
  },
  {
    path: 'kr/content/05faq',
    loadChildren: () =>
      import(
        './staff-page/staff-faq-for-employment-in-japan/staff-faq-for-employment-in-japan.module'
      ).then((m) => m.StaffFaqForEmploymentInJapanModule),
  },
  {
    path: 'cn/content/05faq',
    loadChildren: () =>
      import(
        './staff-page/staff-faq-for-employment-in-japan/staff-faq-for-employment-in-japan.module'
      ).then((m) => m.StaffFaqForEmploymentInJapanModule),
  },
  {
    path: 'service-of-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-service-of-hiwork/staff-service-of-hiwork.module'
      ).then((m) => m.StaffServiceOfHiworkModule),
  },
  {
    path: 'en/service-of-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-service-of-hiwork/staff-service-of-hiwork.module'
      ).then((m) => m.StaffServiceOfHiworkModule),
  },
  {
    path: 'kr/service-of-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-service-of-hiwork/staff-service-of-hiwork.module'
      ).then((m) => m.StaffServiceOfHiworkModule),
  },
  {
    path: 'cn/service-of-hiwork',
    loadChildren: () =>
      import(
        './staff-page/staff-service-of-hiwork/staff-service-of-hiwork.module'
      ).then((m) => m.StaffServiceOfHiworkModule),
  },
  {
    path: 'our-consultants',
    loadChildren: () =>
      import('./staff-page/staff-bteam-info/staff-bteam-info.module').then(
        (m) => m.StaffBteamInfoModule
      ),
  },
  {
    path: 'en/our-consultants',
    loadChildren: () =>
      import('./staff-page/staff-bteam-info/staff-bteam-info.module').then(
        (m) => m.StaffBteamInfoModule
      ),
  },
  {
    path: 'kr/our-consultants',
    loadChildren: () =>
      import('./staff-page/staff-bteam-info/staff-bteam-info.module').then(
        (m) => m.StaffBteamInfoModule
      ),
  },
  {
    path: 'cn/our-consultants',
    loadChildren: () =>
      import('./staff-page/staff-bteam-info/staff-bteam-info.module').then(
        (m) => m.StaffBteamInfoModule
      ),
  },
  {
    path: 'about-scout-email',
    loadChildren: () =>
      import(
        './staff-page/staff-about-scout-email/staff-about-scout-email.module'
      ).then((m) => m.StaffAboutScoutEmailModule),
  },
  {
    path: 'en/about-scout-email',
    loadChildren: () =>
      import(
        './staff-page/staff-about-scout-email/staff-about-scout-email.module'
      ).then((m) => m.StaffAboutScoutEmailModule),
  },
  {
    path: 'kr/about-scout-email',
    loadChildren: () =>
      import(
        './staff-page/staff-about-scout-email/staff-about-scout-email.module'
      ).then((m) => m.StaffAboutScoutEmailModule),
  },
  {
    path: 'cn/about-scout-email',
    loadChildren: () =>
      import(
        './staff-page/staff-about-scout-email/staff-about-scout-email.module'
      ).then((m) => m.StaffAboutScoutEmailModule),
  },
  {
    path: 'interns-recruitment',
    loadChildren: () =>
      import(
        './staff-page/staff-interns-recruitment/staff-interns-recruitment.module'
      ).then((m) => m.StaffInternsRecruitmentModule),
  },
  {
    path: 'en/interns-recruitment',
    loadChildren: () =>
      import(
        './staff-page/staff-interns-recruitment/staff-interns-recruitment.module'
      ).then((m) => m.StaffInternsRecruitmentModule),
  },
  {
    path: 'kr/interns-recruitment',
    loadChildren: () =>
      import(
        './staff-page/staff-interns-recruitment/staff-interns-recruitment.module'
      ).then((m) => m.StaffInternsRecruitmentModule),
  },
  {
    path: 'cn/interns-recruitment',
    loadChildren: () =>
      import(
        './staff-page/staff-interns-recruitment/staff-interns-recruitment.module'
      ).then((m) => m.StaffInternsRecruitmentModule),
  },
  {
    path: 'privacy-and-policy',
    loadChildren: () =>
      import(
        './staff-page/staff-privacy-policy/staff-privacy-policy.module'
      ).then((m) => m.StaffPrivacyPolicyModule),
  },
  {
    path: 'en/privacy-and-policy',
    loadChildren: () =>
      import(
        './staff-page/staff-privacy-policy/staff-privacy-policy.module'
      ).then((m) => m.StaffPrivacyPolicyModule),
  },
  {
    path: 'kr/privacy-and-policy',
    loadChildren: () =>
      import(
        './staff-page/staff-privacy-policy/staff-privacy-policy.module'
      ).then((m) => m.StaffPrivacyPolicyModule),
  },
  {
    path: 'cn/privacy-and-policy',
    loadChildren: () =>
      import(
        './staff-page/staff-privacy-policy/staff-privacy-policy.module'
      ).then((m) => m.StaffPrivacyPolicyModule),
  },
  {
    path: 'service-and-terms',
    loadChildren: () =>
      import(
        './staff-page/staff-service-terms-of-service/staff-service-terms-of-service.module'
      ).then((m) => m.StaffServiceTermsOfServiceModule),
  },
  {
    path: 'en/service-and-terms',
    loadChildren: () =>
      import(
        './staff-page/staff-service-terms-of-service/staff-service-terms-of-service.module'
      ).then((m) => m.StaffServiceTermsOfServiceModule),
  },
  {
    path: 'kr/service-and-terms',
    loadChildren: () =>
      import(
        './staff-page/staff-service-terms-of-service/staff-service-terms-of-service.module'
      ).then((m) => m.StaffServiceTermsOfServiceModule),
  },
  {
    path: 'cn/service-and-terms',
    loadChildren: () =>
      import(
        './staff-page/staff-service-terms-of-service/staff-service-terms-of-service.module'
      ).then((m) => m.StaffServiceTermsOfServiceModule),
  },
  {
    path: 'notes-for-users',
    loadChildren: () =>
      import(
        './staff-page/staff-notes-for-users/staff-notes-for-users.module'
      ).then((m) => m.StaffNotesForUsersModule),
  },
  {
    path: 'en/notes-for-users',
    loadChildren: () =>
      import(
        './staff-page/staff-notes-for-users/staff-notes-for-users.module'
      ).then((m) => m.StaffNotesForUsersModule),
  },
  {
    path: 'kr/notes-for-users',
    loadChildren: () =>
      import(
        './staff-page/staff-notes-for-users/staff-notes-for-users.module'
      ).then((m) => m.StaffNotesForUsersModule),
  },
  {
    path: 'cn/notes-for-users',
    loadChildren: () =>
      import(
        './staff-page/staff-notes-for-users/staff-notes-for-users.module'
      ).then((m) => m.StaffNotesForUsersModule),
  },
  {
    path: 'site-maps',
    loadChildren: () =>
      import('./staff-page/staff-site-map/staff-site-map.module').then(
        (m) => m.StaffSiteMapModule
      ),
  },
  {
    path: 'en/site-maps',
    loadChildren: () =>
      import('./staff-page/staff-site-map/staff-site-map.module').then(
        (m) => m.StaffSiteMapModule
      ),
  },
  {
    path: 'kr/site-maps',
    loadChildren: () =>
      import('./staff-page/staff-site-map/staff-site-map.module').then(
        (m) => m.StaffSiteMapModule
      ),
  },
  {
    path: 'cn/site-maps',
    loadChildren: () =>
      import('./staff-page/staff-site-map/staff-site-map.module').then(
        (m) => m.StaffSiteMapModule
      ),
  },
  {
    path: 'search-early-view',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-early-view/staff-job-search-early-view.module'
      ).then((m) => m.StaffJobSearchEarlyViewModule),
  },
  {
    path: 'en/search-early-view',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-early-view/staff-job-search-early-view.module'
      ).then((m) => m.StaffJobSearchEarlyViewModule),
  },
  {
    path: 'bcause',
    loadChildren: () =>
      import('./staff-page/staff-bcause/staff-bcause.module').then(
        (m) => m.StaffBcauseModule
      ),
  },
  {
    path: 'en/bcause',
    loadChildren: () =>
      import('./staff-page/staff-bcause/staff-bcause.module').then(
        (m) => m.StaffBcauseModule
      ),
  },
  {
    path: 'kr/bcause',
    loadChildren: () =>
      import('./staff-page/staff-bcause/staff-bcause.module').then(
        (m) => m.StaffBcauseModule
      ),
  },
  {
    path: 'cn/bcause',
    loadChildren: () =>
      import('./staff-page/staff-bcause/staff-bcause.module').then(
        (m) => m.StaffBcauseModule
      ),
  },
  {
    path: 'introduce-to-friend/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-introduce-friend/staff-introduce-friend.module'
      ).then((m) => m.StaffIntroduceFriendModule),
  },
  {
    path: 'en/introduce-to-friend/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-introduce-friend/staff-introduce-friend.module'
      ).then((m) => m.StaffIntroduceFriendModule),
  },
  {
    path: 'kr/introduce-to-friend/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-introduce-friend/staff-introduce-friend.module'
      ).then((m) => m.StaffIntroduceFriendModule),
  },
  {
    path: 'cn/introduce-to-friend/:jobCode',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-introduce-friend/staff-introduce-friend.module'
      ).then((m) => m.StaffIntroduceFriendModule),
  },
  {
    path: 'inquiry-mail',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-inquiry-mail/staff-inquiry-mail.module').then(
        (m) => m.StaffInquiryMailModule
      ),
  },
  {
    path: 'en/inquiry-mail',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-inquiry-mail/staff-inquiry-mail.module').then(
        (m) => m.StaffInquiryMailModule
      ),
  },
  {
    path: 'kr/inquiry-mail',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-inquiry-mail/staff-inquiry-mail.module').then(
        (m) => m.StaffInquiryMailModule
      ),
  },
  {
    path: 'cn/inquiry-mail',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-inquiry-mail/staff-inquiry-mail.module').then(
        (m) => m.StaffInquiryMailModule
      ),
  },
  {
    path: 'withdraw',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-withdraw/staff-withdraw.module').then(
        (m) => m.StaffWithdrawModule
      ),
  },
  {
    path: 'en/withdraw',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-withdraw/staff-withdraw.module').then(
        (m) => m.StaffWithdrawModule
      ),
  },
  {
    path: 'kr/withdraw',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-withdraw/staff-withdraw.module').then(
        (m) => m.StaffWithdrawModule
      ),
  },
  {
    path: 'cn/withdraw',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-withdraw/staff-withdraw.module').then(
        (m) => m.StaffWithdrawModule
      ),
  },
  {
    path: 'change-password',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-change-password/staff-change-password.module'
      ).then((m) => m.StaffChangePasswordModule),
  },
  {
    path: 'en/change-password',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-change-password/staff-change-password.module'
      ).then((m) => m.StaffChangePasswordModule),
  },
  {
    path: 'kr/change-password',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-change-password/staff-change-password.module'
      ).then((m) => m.StaffChangePasswordModule),
  },
  {
    path: 'cn/change-password',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-change-password/staff-change-password.module'
      ).then((m) => m.StaffChangePasswordModule),
  },
  {
    path: 'change-email',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-change-email/staff-change-email.module').then(
        (m) => m.StaffChangeEmailModule
      ),
  },
  {
    path: 'en/change-email',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-change-email/staff-change-email.module').then(
        (m) => m.StaffChangeEmailModule
      ),
  },
  {
    path: 'kr/change-email',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-change-email/staff-change-email.module').then(
        (m) => m.StaffChangeEmailModule
      ),
  },
  {
    path: 'cn/change-email',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-change-email/staff-change-email.module').then(
        (m) => m.StaffChangeEmailModule
      ),
  },
  {
    path: 'scout',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-scout/staff-scout.module').then(
        (m) => m.StaffScoutModule
      ),
  },
  {
    path: 'en/scout',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-scout/staff-scout.module').then(
        (m) => m.StaffScoutModule
      ),
  },
  {
    path: 'kr/scout',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-scout/staff-scout.module').then(
        (m) => m.StaffScoutModule
      ),
  },
  {
    path: 'cn/scout',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import('./staff-page/staff-scout/staff-scout.module').then(
        (m) => m.StaffScoutModule
      ),
  },
  {
    path: 'scout-conversation/:JobCode/:StaffId',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-scout-conversation/staff-scout-conversation.module'
      ).then((m) => m.StaffScoutConversationModule),
  },
  {
    path: 'en/scout-conversation/:JobCode/:StaffId',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-scout-conversation/staff-scout-conversation.module'
      ).then((m) => m.StaffScoutConversationModule),
  },
  {
    path: 'kr/scout-conversation/:JobCode/:StaffId',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-scout-conversation/staff-scout-conversation.module'
      ).then((m) => m.StaffScoutConversationModule),
  },
  {
    path: 'cn/scout-conversation/:JobCode/:StaffId',
    canActivate: [StaffAuthGuard],
    loadChildren: () =>
      import(
        './staff-page/staff-scout-conversation/staff-scout-conversation.module'
      ).then((m) => m.StaffScoutConversationModule),
  },
  {
    path: 'company-list',
    loadChildren: () =>
      import('./staff-page/staff-company-list/staff-company-list.module').then(
        (m) => m.StaffCompanyListModule
      ),
  },
  {
    path: 'en/company-list',
    loadChildren: () =>
      import('./staff-page/staff-company-list/staff-company-list.module').then(
        (m) => m.StaffCompanyListModule
      ),
  },
  {
    path: 'kr/company-list',
    loadChildren: () =>
      import('./staff-page/staff-company-list/staff-company-list.module').then(
        (m) => m.StaffCompanyListModule
      ),
  },
  {
    path: 'cn/company-list',
    loadChildren: () =>
      import('./staff-page/staff-company-list/staff-company-list.module').then(
        (m) => m.StaffCompanyListModule
      ),
  },
  {
    path: 'job-list',
    loadChildren: () =>
      import('./staff-page/staff-job-list/staff-job-list.module').then(
        (m) => m.StaffJobListModule
      ),
  },
  {
    path: 'en/job-list',
    loadChildren: () =>
      import('./staff-page/staff-job-list/staff-job-list.module').then(
        (m) => m.StaffJobListModule
      ),
  },
  {
    path: 'kr/job-list',
    loadChildren: () =>
      import('./staff-page/staff-job-list/staff-job-list.module').then(
        (m) => m.StaffJobListModule
      ),
  },
  {
    path: 'cn/job-list',
    loadChildren: () =>
      import('./staff-page/staff-job-list/staff-job-list.module').then(
        (m) => m.StaffJobListModule
      ),
  },
  {
    path: 'tv-interview',
    loadChildren: () =>
      import('./staff-page/staff-tv-interview/staff-tv-interview.module').then(
        (m) => m.StaffTvInterviewModule
      ),
  },
  {
    path: 'en/tv-interview',
    loadChildren: () =>
      import('./staff-page/staff-tv-interview/staff-tv-interview.module').then(
        (m) => m.StaffTvInterviewModule
      ),
  },
  {
    path: 'kr/tv-interview',
    loadChildren: () =>
      import('./staff-page/staff-tv-interview/staff-tv-interview.module').then(
        (m) => m.StaffTvInterviewModule
      ),
  },
  {
    path: 'cn/tv-interview',
    loadChildren: () =>
      import('./staff-page/staff-tv-interview/staff-tv-interview.module').then(
        (m) => m.StaffTvInterviewModule
      ),
  },
  {
    path: 'error-report',
    loadChildren: () =>
      import('./staff-page/staff-error-input/staff-error-input.module').then(
        (m) => m.StaffErrorInputModule
      ),
  },
  {
    path: 'en/error-report',
    loadChildren: () =>
      import('./staff-page/staff-error-input/staff-error-input.module').then(
        (m) => m.StaffErrorInputModule
      ),
  },
  {
    path: 'kr/error-report',
    loadChildren: () =>
      import('./staff-page/staff-error-input/staff-error-input.module').then(
        (m) => m.StaffErrorInputModule
      ),
  },
  {
    path: 'cn/error-report',
    loadChildren: () =>
      import('./staff-page/staff-error-input/staff-error-input.module').then(
        (m) => m.StaffErrorInputModule
      ),
  },
  {
    path: 'job/type/language/english',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-english/staff-job-search-by-english.module'
      ).then((m) => m.StaffJobSearchByEnglishModule),
  },
  {
    path: 'en/job/type/language/english',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-english/staff-job-search-by-english.module'
      ).then((m) => m.StaffJobSearchByEnglishModule),
  },
  {
    path: 'job/type/language/korean',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-korean/staff-job-search-by-korean.module'
      ).then((m) => m.StaffJobSearchByKoreanModule),
  },
  {
    path: 'en/job/type/language/korean',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-korean/staff-job-search-by-korean.module'
      ).then((m) => m.StaffJobSearchByKoreanModule),
  },
  {
    path: 'job/type/language/chinese',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chinese/staff-job-search-by-chinese.module'
      ).then((m) => m.StaffJobSearchByChineseModule),
  },
  {
    path: 'en/job/type/language/chinese',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chinese/staff-job-search-by-chinese.module'
      ).then((m) => m.StaffJobSearchByChineseModule),
  },
  {
    path: 'job_type/speciality/se/programmer',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-programmer/staff-job-search-by-programmer.module'
      ).then((m) => m.StaffJobSearchByProgrammerModule),
  },
  {
    path: 'job/type/language/russian',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-russian/staff-job-search-by-russian.module'
      ).then((m) => m.StaffJobSearchByRussianModule),
  },
  {
    path: 'en/job/type/language/russian',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-russian/staff-job-search-by-russian.module'
      ).then((m) => m.StaffJobSearchByRussianModule),
  },
  {
    path: 'job/type/language/thai',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-thai/staff-job-search-by-thai.module'
      ).then((m) => m.StaffJobSearchByThaiModule),
  },
  {
    path: 'en/job/type/language/thai',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-thai/staff-job-search-by-thai.module'
      ).then((m) => m.StaffJobSearchByThaiModule),
  },

  ////////////////////////////////////////  prefecture /////////////////////////
  {
    path: 'job/type/Place/Hokkaido',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hokkaido/staff-job-search-by-hokkaido.module'
      ).then((m) => m.StaffJobSearchByHokkaidoModule),
  },
  {
    path: 'en/job/type/Place/Hokkaido',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hokkaido/staff-job-search-by-hokkaido.module'
      ).then((m) => m.StaffJobSearchByHokkaidoModule),
  },
  {
    path: 'job/type/Place/tokyoArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tokyo/staff-job-search-by-tokyo.module'
      ).then((m) => m.StaffJobSearchByTokyoModule),
  },
  {
    path: 'en/job/type/Place/tokyoArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tokyo/staff-job-search-by-tokyo.module'
      ).then((m) => m.StaffJobSearchByTokyoModule),
  },
  {
    path: 'job/type/Place/Shiga',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shiga/staff-job-search-by-shiga.module'
      ).then((m) => m.StaffJobSearchByShigaModule),
  },
  {
    path: 'en/job/type/Place/Shiga',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shiga/staff-job-search-by-shiga.module'
      ).then((m) => m.StaffJobSearchByShigaModule),
  },
  {
    path: 'job/type/Place/Kagawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kagawa/staff-job-search-by-kagawa.module'
      ).then((m) => m.StaffJobSearchByKagawaModule),
  },
  {
    path: 'en/job/type/Place/Kagawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kagawa/staff-job-search-by-kagawa.module'
      ).then((m) => m.StaffJobSearchByKagawaModule),
  },

  {
    path: 'job/type/Place/Aomori',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-aomori/staff-job-search-by-aomori.module'
      ).then((m) => m.StaffJobSearchByAomoriModule),
  },
  {
    path: 'en/job/type/Place/Aomori',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-aomori/staff-job-search-by-aomori.module'
      ).then((m) => m.StaffJobSearchByAomoriModule),
  },
  {
    path: 'job/type/Place/Kanagawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kanagawa/staff-job-search-by-kanagawa.module'
      ).then((m) => m.StaffJobSearchByKanagawaModule),
  },
  {
    path: 'en/job/type/Place/Kanagawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kanagawa/staff-job-search-by-kanagawa.module'
      ).then((m) => m.StaffJobSearchByKanagawaModule),
  },

  {
    path: 'job/type/Place/kyotoArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kyoto/staff-job-search-by-kyoto.module'
      ).then((m) => m.StaffJobSearchByKyotoModule),
  },
  {
    path: 'en/job/type/Place/kyotoArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kyoto/staff-job-search-by-kyoto.module'
      ).then((m) => m.StaffJobSearchByKyotoModule),
  },
  {
    path: 'job/type/Place/Ehime',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ehime/staff-job-search-by-ehime.module'
      ).then((m) => m.StaffJobSearchByEhimeModule),
  },
  {
    path: 'en/job/type/Place/Ehime',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ehime/staff-job-search-by-ehime.module'
      ).then((m) => m.StaffJobSearchByEhimeModule),
  },
  {
    path: 'job/type/Place/Iwate',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-iwate/staff-job-search-by-iwate.module'
      ).then((m) => m.StaffJobSearchByIwateModule),
  },
  {
    path: 'en/job/type/Place/Iwate',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-iwate/staff-job-search-by-iwate.module'
      ).then((m) => m.StaffJobSearchByIwateModule),
  },
  {
    path: 'job/type/Place/Niigata',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-niigata/staff-job-search-by-niigata.module'
      ).then((m) => m.StaffJobSearchByNiigataModule),
  },
  {
    path: 'en/job/type/Place/Niigata',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-niigata/staff-job-search-by-niigata.module'
      ).then((m) => m.StaffJobSearchByNiigataModule),
  },
  {
    path: 'job/type/Place/osakaArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-osaka/staff-job-search-by-osaka.module'
      ).then((m) => m.StaffJobSearchByOsakaModule),
  },
  {
    path: 'en/job/type/Place/osakaArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-osaka/staff-job-search-by-osaka.module'
      ).then((m) => m.StaffJobSearchByOsakaModule),
  },
  {
    path: 'job/type/Place/Kochi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kochi/staff-job-search-by-kochi.module'
      ).then((m) => m.StaffJobSearchByKochiModule),
  },
  {
    path: 'en/job/type/Place/Kochi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kochi/staff-job-search-by-kochi.module'
      ).then((m) => m.StaffJobSearchByKochiModule),
  },

  {
    path: 'job/type/Place/Miyagi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-miyagi/staff-job-search-by-miyagi.module'
      ).then((m) => m.StaffJobSearchByMiyagiModule),
  },
  {
    path: 'en/job/type/Place/Miyagi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-miyagi/staff-job-search-by-miyagi.module'
      ).then((m) => m.StaffJobSearchByMiyagiModule),
  },

  {
    path: 'job/type/Place/Toyama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-toyama/staff-job-search-by-toyama.module'
      ).then((m) => m.StaffJobSearchByToyamaModule),
  },
  {
    path: 'en/job/type/Place/Toyama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-toyama/staff-job-search-by-toyama.module'
      ).then((m) => m.StaffJobSearchByToyamaModule),
  },

  {
    path: 'job/type/Place/Hyogo',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hyogo/staff-job-search-by-hyogo.module'
      ).then((m) => m.StaffJobSearchByHyogoModule),
  },
  {
    path: 'en/job/type/Place/Hyogo',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hyogo/staff-job-search-by-hyogo.module'
      ).then((m) => m.StaffJobSearchByHyogoModule),
  },

  {
    path: 'job/type/Place/fukuokaArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukuoka/staff-job-search-by-fukuoka.module'
      ).then((m) => m.StaffJobSearchByFukuokaModule),
  },
  {
    path: 'en/job/type/Place/fukuokaArea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukuoka/staff-job-search-by-fukuoka.module'
      ).then((m) => m.StaffJobSearchByFukuokaModule),
  },

  {
    path: 'job/type/Place/Akita',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-akita/staff-job-search-by-akita.module'
      ).then((m) => m.StaffJobSearchByAkitaModule),
  },
  {
    path: 'en/job/type/Place/Akita',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-akita/staff-job-search-by-akita.module'
      ).then((m) => m.StaffJobSearchByAkitaModule),
  },
  {
    path: 'job/type/Place/Ishikawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ishikawa/staff-job-search-by-ishikawa.module'
      ).then((m) => m.StaffJobSearchByIshikawaModule),
  },
  {
    path: 'en/job/type/Place/Ishikawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ishikawa/staff-job-search-by-ishikawa.module'
      ).then((m) => m.StaffJobSearchByIshikawaModule),
  },
  {
    path: 'job/type/Place/Nara',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nara/staff-job-search-by-nara.module'
      ).then((m) => m.StaffJobSearchByNaraModule),
  },
  {
    path: 'en/job/type/Place/Nara',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nara/staff-job-search-by-nara.module'
      ).then((m) => m.StaffJobSearchByNaraModule),
  },
  {
    path: 'job/type/Place/Saga',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-saga/staff-job-search-by-saga.module'
      ).then((m) => m.StaffJobSearchBySagaModule),
  },
  {
    path: 'en/job/type/Place/Saga',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-saga/staff-job-search-by-saga.module'
      ).then((m) => m.StaffJobSearchBySagaModule),
  },
  {
    path: 'job/type/Place/Yamagata',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamagata/staff-job-search-by-yamagata.module'
      ).then((m) => m.StaffJobSearchByYamagataModule),
  },
  {
    path: 'en/job/type/Place/Yamagata',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamagata/staff-job-search-by-yamagata.module'
      ).then((m) => m.StaffJobSearchByYamagataModule),
  },
  {
    path: 'job/type/Place/Fukui',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukui/staff-job-search-by-fukui.module'
      ).then((m) => m.StaffJobSearchByFukuiModule),
  },
  {
    path: 'en/job/type/Place/Fukui',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukui/staff-job-search-by-fukui.module'
      ).then((m) => m.StaffJobSearchByFukuiModule),
  },
  {
    path: 'job/type/Place/Wakayama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-wakayama/staff-job-search-by-wakayama.module'
      ).then((m) => m.StaffJobSearchByWakayamaModule),
  },
  {
    path: 'en/job/type/Place/Wakayama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-wakayama/staff-job-search-by-wakayama.module'
      ).then((m) => m.StaffJobSearchByWakayamaModule),
  },

  {
    path: 'job/type/Place/Nagasaki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nagasaki/staff-job-search-by-nagasaki.module'
      ).then((m) => m.StaffJobSearchByNagasakiModule),
  },
  {
    path: 'en/job/type/Place/Nagasaki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nagasaki/staff-job-search-by-nagasaki.module'
      ).then((m) => m.StaffJobSearchByNagasakiModule),
  },

  {
    path: 'job/type/Place/Fukushima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukushima/staff-job-search-by-fukushima.module'
      ).then((m) => m.StaffJobSearchByFukushimaModule),
  },
  {
    path: 'en/job/type/Place/Fukushima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-fukushima/staff-job-search-by-fukushima.module'
      ).then((m) => m.StaffJobSearchByFukushimaModule),
  },

  {
    path: 'job/type/Place/Yamanashi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamanashi/staff-job-search-by-yamanashi.module'
      ).then((m) => m.StaffJobSearchByYamanashiModule),
  },
  {
    path: 'en/job/type/Place/Yamanashi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamanashi/staff-job-search-by-yamanashi.module'
      ).then((m) => m.StaffJobSearchByYamanashiModule),
  },
  {
    path: 'job/type/Place/Tottori',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tottori/staff-job-search-by-tottori.module'
      ).then((m) => m.StaffJobSearchByTottoriModule),
  },
  {
    path: 'en/job/type/Place/Tottori',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tottori/staff-job-search-by-tottori.module'
      ).then((m) => m.StaffJobSearchByTottoriModule),
  },
  {
    path: 'job/type/Place/Kumamoto',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kumamoto/staff-job-search-by-kumamoto.module'
      ).then((m) => m.StaffJobSearchByKumamotoModule),
  },
  {
    path: 'en/job/type/Place/Kumamoto',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kumamoto/staff-job-search-by-kumamoto.module'
      ).then((m) => m.StaffJobSearchByKumamotoModule),
  },

  {
    path: 'job/type/Place/Ibaraki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ibaraki/staff-job-search-by-ibaraki.module'
      ).then((m) => m.StaffJobSearchByIbarakiModule),
  },
  {
    path: 'en/job/type/Place/Ibaraki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ibaraki/staff-job-search-by-ibaraki.module'
      ).then((m) => m.StaffJobSearchByIbarakiModule),
  },
  {
    path: 'job/type/Place/Nagano',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nagano/staff-job-search-by-nagano.module'
      ).then((m) => m.StaffJobSearchByNaganoModule),
  },
  {
    path: 'en/job/type/Place/Nagano',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-nagano/staff-job-search-by-nagano.module'
      ).then((m) => m.StaffJobSearchByNaganoModule),
  },
  {
    path: 'job/type/Place/Shimane',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shimane/staff-job-search-by-shimane.module'
      ).then((m) => m.StaffJobSearchByShimaneModule),
  },
  {
    path: 'en/job/type/Place/shimane',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shimane/staff-job-search-by-shimane.module'
      ).then((m) => m.StaffJobSearchByShimaneModule),
  },
  {
    path: 'job/type/Place/Oita',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-oita/staff-job-search-by-oita.module'
      ).then((m) => m.StaffJobSearchByOitaModule),
  },
  {
    path: 'en/job/type/Place/Oita',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-oita/staff-job-search-by-oita.module'
      ).then((m) => m.StaffJobSearchByOitaModule),
  },
  {
    path: 'job/type/Place/Tochigi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tochigi/staff-job-search-by-tochigi.module'
      ).then((m) => m.StaffJobSearchByTochigiModule),
  },
  {
    path: 'en/job/type/Place/Gifu',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-gifu/staff-job-search-by-gifu.module'
      ).then((m) => m.StaffJobSearchByGifuModule),
  },
  {
    path: 'job/type/Place/Gifu',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-gifu/staff-job-search-by-gifu.module'
      ).then((m) => m.StaffJobSearchByGifuModule),
  },
  {
    path: 'job/type/Place/Okayama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-okayama/staff-job-search-by-okayama.module'
      ).then((m) => m.StaffJobSearchByOkayamaModule),
  },
  {
    path: 'en/job/type/Place/Okayama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-okayama/staff-job-search-by-okayama.module'
      ).then((m) => m.StaffJobSearchByOkayamaModule),
  },
  {
    path: 'job/type/Place/Miyazaki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-miyazaki/staff-job-search-by-miyazaki.module'
      ).then((m) => m.StaffJobSearchByMiyazakiModule),
  },
  {
    path: 'en/job/type/Place/Miyazaki',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-miyazaki/staff-job-search-by-miyazaki.module'
      ).then((m) => m.StaffJobSearchByMiyazakiModule),
  },
  {
    path: 'job/type/Place/Gumma',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-gumma/staff-job-search-by-gumma.module'
      ).then((m) => m.StaffJobSearchByGummaModule),
  },
  {
    path: 'en/job/type/Place/Gumma',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-gumma/staff-job-search-by-gumma.module'
      ).then((m) => m.StaffJobSearchByGummaModule),
  },
  {
    path: 'job/type/Place/Shizuoka',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shizuoka/staff-job-search-by-shizuoka.module'
      ).then((m) => m.StaffJobSearchByShizuokaModule),
  },
  {
    path: 'en/job/type/Place/Shizuoka',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-shizuoka/staff-job-search-by-shizuoka.module'
      ).then((m) => m.StaffJobSearchByShizuokaModule),
  },
  {
    path: 'job/type/Place/Hiroshima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hiroshima/staff-job-search-by-hiroshima.module'
      ).then((m) => m.StaffJobSearchByHiroshimaModule),
  },
  {
    path: 'en/job/type/Place/Hiroshima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hiroshima/staff-job-search-by-hiroshima.module'
      ).then((m) => m.StaffJobSearchByHiroshimaModule),
  },
  {
    path: 'job/type/Place/Kagoshima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kagoshima/staff-job-search-by-kagoshima.module'
      ).then((m) => m.StaffJobSearchByKagoshimaModule),
  },
  {
    path: 'en/job/type/Place/Kagoshima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kagoshima/staff-job-search-by-kagoshima.module'
      ).then((m) => m.StaffJobSearchByKagoshimaModule),
  },
  {
    path: 'job/type/Place/Saitama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-saitama/staff-job-search-by-saitama.module'
      ).then((m) => m.StaffJobSearchBySaitamaModule),
  },
  {
    path: 'en/job/type/Place/Saitama',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-saitama/staff-job-search-by-saitama.module'
      ).then((m) => m.StaffJobSearchBySaitamaModule),
  },
  {
    path: 'job/type/Place/Aichi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-Aichi/staff-job-search-by-Aichi.module'
      ).then((m) => m.StaffJobSearchByAichiModule),
  },
  {
    path: 'en/job/type/Place/Aichi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-Aichi/staff-job-search-by-Aichi.module'
      ).then((m) => m.StaffJobSearchByAichiModule),
  },
  {
    path: 'job/type/Place/Yamaguchi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamaguchi/staff-job-search-by-yamaguchi.module'
      ).then((m) => m.StaffJobSearchByYamaguchiModule),
  },
  {
    path: 'en/job/type/Place/Yamaguchi',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-yamaguchi/staff-job-search-by-yamaguchi.module'
      ).then((m) => m.StaffJobSearchByYamaguchiModule),
  },
  {
    path: 'job/type/Place/Okinawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-okinawa/staff-job-search-by-okinawa.module'
      ).then((m) => m.StaffJobSearchByOkinawaModule),
  },
  {
    path: 'en/job/type/Place/Okinawa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-okinawa/staff-job-search-by-okinawa.module'
      ).then((m) => m.StaffJobSearchByOkinawaModule),
  },
  {
    path: 'job/type/Place/Chiba',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chiba/staff-job-search-by-chiba.module'
      ).then((m) => m.StaffJobSearchByChibaModule),
  },
  {
    path: 'en/job/type/Place/Chiba',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chiba/staff-job-search-by-chiba.module'
      ).then((m) => m.StaffJobSearchByChibaModule),
  },
  {
    path: 'job/type/Place/Mie',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-mie/staff-job-search-by-mie.module'
      ).then((m) => m.StaffJobSearchByMieModule),
  },
  {
    path: 'en/job/type/Place/Mie',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-mie/staff-job-search-by-mie.module'
      ).then((m) => m.StaffJobSearchByMieModule),
  },
  {
    path: 'job/type/Place/Tokushima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tokushima/staff-job-search-by-tokushima.module'
      ).then((m) => m.StaffJobSearchByTokushimaModule),
  },
  {
    path: 'en/job/type/Place/Tokushima',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tokushima/staff-job-search-by-tokushima.module'
      ).then((m) => m.StaffJobSearchByTokushimaModule),
  },
  {
    path: 'job/type/Place/Japanese',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-japan/staff-job-search-by-japan.module'
      ).then((m) => m.StaffJobSearchByJapanModule),
  },
  {
    path: 'en/job/type/Place/Japanese',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-japan/staff-job-search-by-japan.module'
      ).then((m) => m.StaffJobSearchByJapanModule),
  },
  {
    path: 'job/type/Place/North_Korea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-north-korea/staff-job-search-by-north-korea.module'
      ).then((m) => m.StaffJobSearchByNorthKoreaModule),
  },
  {
    path: 'en/job/type/Place/North_Korea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-north-korea/staff-job-search-by-north-korea.module'
      ).then((m) => m.StaffJobSearchByNorthKoreaModule),
  },
  {
    path: 'job/type/Place/Czech',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-czech-republic/staff-job-search-by-czech-republic.module'
      ).then((m) => m.StaffJobSearchByCzechRepublicModule),
  },
  {
    path: 'en/job/type/Place/Czech',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-czech-republic/staff-job-search-by-czech-republic.module'
      ).then((m) => m.StaffJobSearchByCzechRepublicModule),
  },
  {
    path: 'job/type/Place/Venezuela',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-venezuela/staff-job-search-by-venezuela.module'
      ).then((m) => m.StaffJobSearchByVenezuelaModule),
  },
  {
    path: 'en/job/type/Place/Venezuela',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-venezuela/staff-job-search-by-venezuela.module'
      ).then((m) => m.StaffJobSearchByVenezuelaModule),
  },
  {
    path: 'job/type/Place/Korea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-korea/staff-job-search-by-korea.module'
      ).then((m) => m.StaffJobSearchByKoreaModule),
  },
  {
    path: 'en/job/type/Place/Korea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-korea/staff-job-search-by-korea.module'
      ).then((m) => m.StaffJobSearchByKoreaModule),
  },
  {
    path: 'job/type/Place/Guinea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-guinea/staff-job-search-by-guinea.module'
      ).then((m) => m.StaffJobSearchByGuineaModule),
  },
  {
    path: 'en/job/type/Place/Guinea',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-guinea/staff-job-search-by-guinea.module'
      ).then((m) => m.StaffJobSearchByGuineaModule),
  },
  {
    path: 'job/type/Place/Chad',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chad/staff-job-search-by-chad.module'
      ).then((m) => m.StaffJobSearchByChadModule),
  },
  {
    path: 'en/job/type/Place/Chad',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chad/staff-job-search-by-chad.module'
      ).then((m) => m.StaffJobSearchByChadModule),
  },
  {
    path: 'job/type/Place/Belarus',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belarus/staff-job-search-by-belarus.module'
      ).then((m) => m.StaffJobSearchByBelarusModule),
  },
  {
    path: 'en/job/type/Place/Belarus',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belarus/staff-job-search-by-belarus.module'
      ).then((m) => m.StaffJobSearchByBelarusModule),
  },
  {
    path: 'job/type/Place/China',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-china/staff-job-search-by-china.module'
      ).then((m) => m.StaffJobSearchByChinaModule),
  },
  {
    path: 'en/job/type/Place/China',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-china/staff-job-search-by-china.module'
      ).then((m) => m.StaffJobSearchByChinaModule),
  },
  {
    path: 'job/type/Place/Cyprus',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-cyprus/staff-job-search-by-cyprus.module'
      ).then((m) => m.StaffJobSearchByCyprusModule),
  },
  {
    path: 'en/job/type/Place/Cyprus',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-cyprus/staff-job-search-by-cyprus.module'
      ).then((m) => m.StaffJobSearchByCyprusModule),
  },
  {
    path: 'job/type/Place/Tunisia',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tunisia/staff-job-search-by-tunisia.module'
      ).then((m) => m.StaffJobSearchByTunisiaModule),
  },
  {
    path: 'en/job/type/Place/Tunisia',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tunisia/staff-job-search-by-tunisia.module'
      ).then((m) => m.StaffJobSearchByTunisiaModule),
  },
  {
    path: 'job/type/Place/Belize',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belize/staff-job-search-by-belize.module'
      ).then((m) => m.StaffJobSearchByBelizeModule),
  },
  {
    path: 'en/job/type/Place/Belize',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belize/staff-job-search-by-belize.module'
      ).then((m) => m.StaffJobSearchByBelizeModule),
  },
  {
    path: 'job/type/Place/Iceland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-iceland/staff-job-search-by-iceland.module'
      ).then((m) => m.StaffJobSearchByIcelandModule),
  },
  {
    path: 'en/job/type/Place/Iceland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-iceland/staff-job-search-by-iceland.module'
      ).then((m) => m.StaffJobSearchByIcelandModule),
  },
  {
    path: 'job/type/Place/Cuba',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-cuba/staff-job-search-by-cuba.module'
      ).then((m) => m.StaffJobSearchByCubaModule),
  },
  {
    path: 'en/job/type/Place/Cuba',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-cuba/staff-job-search-by-cuba.module'
      ).then((m) => m.StaffJobSearchByCubaModule),
  },

  {
    path: 'job/type/Place/Chile',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chile/staff-job-search-by-chile.module'
      ).then((m) => m.StaffJobSearchByChileModule),
  },
  {
    path: 'en/job/type/Place/Chile',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-chile/staff-job-search-by-chile.module'
      ).then((m) => m.StaffJobSearchByChileModule),
  },
  {
    path: 'job/type/Place/Peru',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-peru/staff-job-search-by-peru.module'
      ).then((m) => m.StaffJobSearchByPeruModule),
  },
  {
    path: 'en/job/type/Place/Peru',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-peru/staff-job-search-by-peru.module'
      ).then((m) => m.StaffJobSearchByPeruModule),
  },

  {
    path: 'job/type/Place/Ireland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ireland/staff-job-search-by-ireland.module'
      ).then((m) => m.StaffJobSearchByIrelandModule),
  },
  {
    path: 'en/job/type/Place/Ireland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-ireland/staff-job-search-by-ireland.module'
      ).then((m) => m.StaffJobSearchByIrelandModule),
  },

  {
    path: 'job/type/Place/Hellenic',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hellenic/staff-job-search-by-hellenic.module'
      ).then((m) => m.StaffJobSearchByHellenicModule),
  },
  {
    path: 'en/job/type/Place/Hellenic',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-hellenic/staff-job-search-by-hellenic.module'
      ).then((m) => m.StaffJobSearchByHellenicModule),
  },

  {
    path: 'job/type/Place/Central_Africa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-central-africa/staff-job-search-by-central-africa.module'
      ).then((m) => m.StaffJobSearchByCentralAfricaModule),
  },
  {
    path: 'en/job/type/Place/Central_Africa',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-central-africa/staff-job-search-by-central-africa.module'
      ).then((m) => m.StaffJobSearchByCentralAfricaModule),
  },

  {
    path: 'job/type/Place/Belgium',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belgium/staff-job-search-by-belgium.module'
      ).then((m) => m.StaffJobSearchByBelgiumModule),
  },
  {
    path: 'en/job/type/Place/Belgium',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-belgium/staff-job-search-by-belgium.module'
      ).then((m) => m.StaffJobSearchByBelgiumModule),
  },
  {
    path: 'job/type/Place/Azerbaijan',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-azerbaijan/staff-job-search-by-azerbaijan.module'
      ).then((m) => m.StaffJobSearchByAzerbaijanModule),
  },
  {
    path: 'en/job/type/Place/Azerbaijan',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-azerbaijan/staff-job-search-by-azerbaijan.module'
      ).then((m) => m.StaffJobSearchByAzerbaijanModule),
  },

  {
    path: 'job/type/Place/Kiribati',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kiribati/staff-job-search-by-kiribati.module'
      ).then((m) => m.StaffJobSearchByKiribatiModule),
  },
  {
    path: 'en/job/type/Place/Kiribati',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-kiribati/staff-job-search-by-kiribati.module'
      ).then((m) => m.StaffJobSearchByKiribatiModule),
  },
  {
    path: 'job/type/Place/Tuvalu',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tuvalu/staff-job-search-by-tuvalu.module'
      ).then((m) => m.StaffJobSearchByTuvaluModule),
  },
  {
    path: 'en/job/type/Place/Tuvalu',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-tuvalu/staff-job-search-by-tuvalu.module'
      ).then((m) => m.StaffJobSearchByTuvaluModule),
  },
  {
    path: 'job/type/Place/Poland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-poland/staff-job-search-by-poland.module'
      ).then((m) => m.StaffJobSearchByPolandModule),
  },
  {
    path: 'en/job/type/Place/Poland',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-poland/staff-job-search-by-poland.module'
      ).then((m) => m.StaffJobSearchByPolandModule),
  },

  {
    path: 'job/type/Place/Afghanistan',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-afghanistan/staff-job-search-by-afghanistan.module'
      ).then((m) => m.StaffJobSearchByAfghanistanModule),
  },


  //StaffJobSearchByKanagawaModule  //na
  {
    path: 'job/type/jpnlanguage/native',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-jplang-native/staff-job-search-by-jplang-native.module'
      ).then((m) => m.StaffJobSearchByJplangNativeModule),
  },
  {
    path: 'en/job/type/jpnlanguage/native',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-jplang-native/staff-job-search-by-jplang-native.module'
      ).then((m) => m.StaffJobSearchByJplangNativeModule),
  },
  {
    path: 'job/type/jpnlanguage/none',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-jplang-none/staff-job-search-by-jplang-none.module'
      ).then((m) => m.StaffJobSearchByJplangNoneModule),
  },
  {
    path: 'en/job/type/jpnlanguage/none',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-jplang-none/staff-job-search-by-jplang-none.module'
      ).then((m) => m.StaffJobSearchByJplangNoneModule),
  },
  {
    path: 'job_type/speciality/interpretation/translation',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-interpretation-translation/staff-job-search-by-interpretation-translation.module'
      ).then((m) => m.StaffJobSearchByInterpretationTranslationModule),
  },
  {
    path: 'en/job_type/speciality/interpretation/translation',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-interpretation-translation/staff-job-search-by-interpretation-translation.module'
      ).then((m) => m.StaffJobSearchByInterpretationTranslationModule),
  },

  {
    path: 'job/type/employ/parttime',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-others-employee/staff-job-search-by-others-employee.module'
      ).then((m) => m.StaffJobSearchByOthersEmployeeModule),
  },
  {
    path: 'en/job/type/employ/parttime',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-others-employee/staff-job-search-by-others-employee.module'
      ).then((m) => m.StaffJobSearchByOthersEmployeeModule),
  },
  {
    path: 'job/type/employ/contract',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-contractual-employee/staff-job-search-by-contractual-employee.module'
      ).then((m) => m.StaffJobSearchByContractualEmployeeModule),
  },
  {
    path: 'en/job/type/employ/contract',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-contractual-employee/staff-job-search-by-contractual-employee.module'
      ).then((m) => m.StaffJobSearchByContractualEmployeeModule),
  },
  {
    path: 'job/type/employ/dispatch',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-dispatch-employee/staff-job-search-by-dispatch-employee.module'
      ).then((m) => m.StaffJobSearchByDispatchEmployeeModule),
  },
  {
    path: 'en/job/type/employ/dispatch',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-dispatch-employee/staff-job-search-by-dispatch-employee.module'
      ).then((m) => m.StaffJobSearchByDispatchEmployeeModule),
  },
  {
    path: 'job/type/employ/regular',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-permanent-employe/staff-job-search-by-permanent-employe.module'
      ).then((m) => m.StaffJobSearchByPermanentEmployeModule),
  },
  {
    path: 'en/job/type/employ/regular',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-permanent-employe/staff-job-search-by-permanent-employe.module'
      ).then((m) => m.StaffJobSearchByPermanentEmployeModule),
  },
  {
    path: 'job/type/employ/freelance',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-freelance-employee/staff-job-search-by-freelance-employee.module'
      ).then((m) => m.StaffJobSearchByFreelanceEmployeeModule),
  },
  {
    path: 'en/job/type/employ/freelance',
    loadChildren: () =>
      import(
        './staff-page/staff-job-search-by-freelance-employee/staff-job-search-by-freelance-employee.module'
      ).then((m) => m.StaffJobSearchByFreelanceEmployeeModule),
  },

  {
    path: 'client/details',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-details/company-details.module').then(
        (m) => m.CompanyDetailsModule
      ),
  },
  {
    path: 'en/client/details',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-details/company-details.module').then(
        (m) => m.CompanyDetailsModule
      ),
  },
   {
    path: 'client/change-password',
     canActivate: [AuthGuard],
    loadChildren: () =>
       import(
         './company-page/company-change-password/company-change-password.module'
       ).then((m) => m.CompanyChangePasswordModule),
   },
   {
     path: 'en/client/change-password',
     canActivate: [AuthGuard],
     loadChildren: () =>
       import(
         './company-page/company-change-password/company-change-password.module'
      ).then((m) => m.CompanyChangePasswordModule),
   },
   {
     path: 'client/change-email',
     canActivate: [AuthGuard],
     loadChildren: () =>
       import(
         './company-page/company-change-email/company-change-email.module'
       ).then((m) => m.CompanyChangeEmailModule),
   },
   {
     path: 'en/client/change-email',
     canActivate: [AuthGuard],
     loadChildren: () =>
       import(
         './company-page/company-change-email/company-change-email.module'
       ).then((m) => m.CompanyChangeEmailModule),
   },

  {
    path: 'en/client/job-list',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-job-list/company-job-list.module').then(
        (m) => m.CompanyJobListModule
      ),
  },
  {
    path: 'client/agent-list',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-agent-list/company-agent-list.module'
      ).then((m) => m.CompanyAgentListModule),
  },
  {
    path: 'en/client/agent-list',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-agent-list/company-agent-list.module'
      ).then((m) => m.CompanyAgentListModule),
  },
  {
    path: 'client/agent-details/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/agent-details/agent-details.module').then(
        (m) => m.AgentDetailsModule
      ),
  },
  {
    path: 'en/client/agent-details/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/agent-details/agent-details.module').then(
        (m) => m.AgentDetailsModule
      ),
  },
  {
    path: 'client/agent-edit/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/agent-edit/agent-edit.module').then(
        (m) => m.AgentEditModule
      ),
  },
  {
    path: 'en/client/agent-edit/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/agent-edit/agent-edit.module').then(
        (m) => m.AgentEditModule
      ),
  },

  {
    path: 'client/job-posting-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-posting-preview/company-job-posting-preview.module'
      ).then((m) => m.CompanyJobPostingPreviewModule),
  },
  {
    path: 'en/client/job-posting-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-posting-preview/company-job-posting-preview.module'
      ).then((m) => m.CompanyJobPostingPreviewModule),
  },
  {
    path: 'client/job-posting-edit-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-posting-edit-preview/company-job-posting-edit-preview.module'
      ).then((m) => m.CompanyJobPostingEditPreviewModule),
  },
  {
    path: 'en/client/job-posting-edit-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-posting-edit-preview/company-job-posting-edit-preview.module'
      ).then((m) => m.CompanyJobPostingEditPreviewModule),
  },

  {
    path: 'client/registration',
    canActivate: [AnonymousClientAuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-registration/company-registration.module'
      ).then((m) => m.CompanyRegistrationModule),
  },
  {
    path: 'en/client/registration',
    canActivate: [AnonymousClientAuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-registration/company-registration.module'
      ).then((m) => m.CompanyRegistrationModule),
  },
  {
    path: 'client/registration-preview',
    canActivate: [AnonymousClientAuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-registration-preview/company-registration-preview.module'
      ).then((m) => m.CompanyRegistrationPreviewModule),
  },
  {
    path: 'client/verify-email-for-client-registration/:code/:companyId',
    loadChildren: () =>
      import(
        './company-page/company-registration-email-verify/company-registration-email-verify.module'
      ).then((m) => m.CompanyRegistrationEmailVerifyModule),
  },
  {
    path: 'en/client/registration-preview',
    canActivate: [AnonymousClientAuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-registration-preview/company-registration-preview.module'
      ).then((m) => m.CompanyRegistrationPreviewModule),
  },
  {
    path: 'en/client/edit',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-edit/company-edit.module').then(
        (m) => m.CompanyEditModule
      ),
  },
  {
    path: 'jp/client/verify-email-for-client-registration/:code/:companyId',
    loadChildren: () =>
      import(
        './company-page/company-registration-email-verify/company-registration-email-verify.module'
      ).then((m) => m.CompanyRegistrationEmailVerifyModule),
  },
  {
    path: 'en/client/verify-email-for-client-registration/:code/:companyId',
    loadChildren: () =>
      import(
        './company-page/company-registration-email-verify/company-registration-email-verify.module'
      ).then((m) => m.CompanyRegistrationEmailVerifyModule),
  },

  {
    path: 'client/edit-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-edit-preview/company-edit-preview.module'
      ).then((m) => m.CompanyEditPreviewModule),
  },
  {
    path: 'en/client/edit-preview',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-edit-preview/company-edit-preview.module'
      ).then((m) => m.CompanyEditPreviewModule),
  },
  {
    path: 'en/client/my-page',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-my-page/company-my-page.module').then(
        (m) => m.CompanyMyPageModule
      ),
  },
  
  {
    path: 'client/company-profile',
    loadChildren: () =>
      import(
        './company-page/company-how-to-use-contast-us/company-contact-us.module'
      ).then((m) => m.CompanyHowToUseContactUsModule),
  },
  {
    path: 'en/client/company-profile',
    loadChildren: () =>
      import(
        './company-page/company-how-to-use-contast-us/company-contact-us.module'
      ).then((m) => m.CompanyHowToUseContactUsModule),
  },
  {
    path: 'kr/client/company-profile',
    loadChildren: () =>
      import(
        './company-page/company-how-to-use-contast-us/company-contact-us.module'
      ).then((m) => m.CompanyHowToUseContactUsModule),
  },
  {
    path: 'client/privacy-policy',
    loadChildren: () =>
      import(
        './company-page/company-privacy-policy/company-privacy-policy.module'
      ).then((m) => m.CompanyPrivacyPolicyModule),
  },
  {
    path: 'en/client/privacy-policy',
    loadChildren: () =>
      import(
        './company-page/company-privacy-policy/company-privacy-policy.module'
      ).then((m) => m.CompanyPrivacyPolicyModule),
  },
  {
    path: 'client/posted-notes',
    loadChildren: () =>
      import(
        './company-page/company-posted-notes/company-posted-notes.module'
      ).then((m) => m.CompanyPostedNotesModule),
  },
  {
    path: 'en/client/posted-notes',
    loadChildren: () =>
      import(
        './company-page/company-posted-notes/company-posted-notes.module'
      ).then((m) => m.CompanyPostedNotesModule),
  },
  {
    path: 'client/recommendation',
    loadChildren: () =>
      import(
        './company-page/company-recommendation/company-recommendation.module'
      ).then((m) => m.CompanyRecommendationModule),
  },
  {
    path: 'en/client/recommendation',
    loadChildren: () =>
      import(
        './company-page/company-recommendation/company-recommendation.module'
      ).then((m) => m.CompanyRecommendationModule),
  },
  {
    path: 'client/site-map',
    loadChildren: () =>
      import('./company-page/company-site-map/company-site-map.module').then(
        (m) => m.CompanySiteMapModule
      ),
  },
  {
    path: 'en/client/site-map',
    loadChildren: () =>
      import('./company-page/company-site-map/company-site-map.module').then(
        (m) => m.CompanySiteMapModule
      ),
  },
  {
    path: 'client/terms-of-services',
    loadChildren: () =>
      import(
        './company-page/company-terms-of-service/company-terms-of-service.module'
      ).then((m) => m.CompanyTermsOfServiceModule),
  },
  {
    path: 'en/client/terms-of-services',
    loadChildren: () =>
      import(
        './company-page/company-terms-of-service/company-terms-of-service.module'
      ).then((m) => m.CompanyTermsOfServiceModule),
  },

  {
    path: 'client/white-paper',
    loadChildren: () =>
      import(
        './company-page/company-white-paper/company-white-paper.module'
      ).then((m) => m.CompanyWhitePaperModule),
  },
  {
    path: 'en/client/white-paper',
    loadChildren: () =>
      import(
        './company-page/company-white-paper/company-white-paper.module'
      ).then((m) => m.CompanyWhitePaperModule),
  },
  {
    path: 'client/estimation/:estimationNo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/estimation/estimation.module').then(
        (m) => m.EstimationModule
      ),
  },
  {
    path: 'en/client/estimation/:estimationNo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/estimation/estimation.module').then(
        (m) => m.EstimationModule
      ),
  },
  {
    path: 'client/banner-estimation/:estimationNo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-estimation/company-banner-estimation.module'
      ).then((m) => m.CompanyBannerEstimationModule),
  },
  {
    path: 'en/client/banner-estimation/:estimationNo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-estimation/company-banner-estimation.module'
      ).then((m) => m.CompanyBannerEstimationModule),
  },

  {
    path: 'client/banner-advertisement-upload',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-advertisement-step2/company-banner-advertisement-step2.module'
      ).then((m) => m.CompanyBannerAdvertisementStep2Module),
  },
  {
    path: 'en/client/banner-advertisement-upload',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-advertisement-step2/company-banner-advertisement-step2.module'
      ).then((m) => m.CompanyBannerAdvertisementStep2Module),
  },
  {
    path: 'client/banner-advertisement-re-post/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-advertisement-re-post/company-banner-advertisement-re-post.module'
      ).then((m) => m.CompanyBannerAdvertisementRePostModule),
  },
  {
    path: 'en/client/banner-advertisement-re-post/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-banner-advertisement-re-post/company-banner-advertisement-re-post.module'
      ).then((m) => m.CompanyBannerAdvertisementRePostModule),
  },

  {
    path: 'client/option-estimation/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-option-estimation/company-option-estimation.module'
      ).then((m) => m.CompanyOptionEstimationModule),
  },
  {
    path: 'en/client/option-estimation/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-option-estimation/company-option-estimation.module'
      ).then((m) => m.CompanyOptionEstimationModule),
  },

  {
    path: 'client/payment-method',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/payment-method/payment-method.module').then(
        (m) => m.PaymentMethodModule
      ),
  },
  {
    path: 'en/client/payment-method',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/payment-method/payment-method.module').then(
        (m) => m.PaymentMethodModule
      ),
  },
  {
    path: 'client/review-resume/:staffCode',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-review-resume/company-review-resume.module'
      ).then((m) => m.CompanyReviewOfResumeModule),
  },
  {
    path: 'en/client/review-resume/:staffCode',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-review-resume/company-review-resume.module'
      ).then((m) => m.CompanyReviewOfResumeModule),
  },
  {
    path: 'client/applicant-resume/:staffID/:jobId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/applicant-review-resume/applicant-review-resume.module'
      ).then((m) => m.ApplicantReviewResumeModule),
  },
  {
    path: 'en/client/applicant-resume/:staffID/:jobId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/applicant-review-resume/applicant-review-resume.module'
      ).then((m) => m.ApplicantReviewResumeModule),
  },
 
 
  {
    path: 'client/settlement/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/settlement/settlement.module').then(
        (m) => m.SettlementModule
      ),
  },
  {
    path: 'en/client/settlement/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/settlement/settlement.module').then(
        (m) => m.SettlementModule
      ),
  },

  {
    path: 'client/faq',
    loadChildren: () =>
      import('./company-page/company-faq/company-faq.module').then(
        (m) => m.CompanyFAQModule
      ),
  },
  {
    path: 'en/client/faq',
    loadChildren: () =>
      import('./company-page/company-faq/company-faq.module').then(
        (m) => m.CompanyFAQModule
      ),
  },
  

  {
    path: 'en/client/staff-search',
    loadChildren: () =>
      import(
        './company-page/company-staff-search/company-staff-search.module'
      ).then((m) => m.CompanyStaffSearchModule),
  },
  {
    path: 'client/staff-search/:id/:type',
    loadChildren: () =>
      import(
        './company-page/company-staff-search/company-staff-search.module'
      ).then((m) => m.CompanyStaffSearchModule),
  },
  {
    path: 'en/client/staff-search/:id/:type',
    loadChildren: () =>
      import(
        './company-page/company-staff-search/company-staff-search.module'
      ).then((m) => m.CompanyStaffSearchModule),
  },


  {
    path: 'en/client/labor-market',
    loadChildren: () =>
      import(
        './company-page/company-labor-market/company-labor-market.module'
      ).then((m) => m.CompanyLaborMarketModule),
  },
  {
    path: 'client/labor-market',
    loadChildren: () =>
      import(
        './company-page/company-labor-market/company-labor-market.module'
      ).then((m) => m.CompanyLaborMarketModule),
  },
  {
    path: 'en/client/how-to-use-mypage',
    loadChildren: () =>
      import(
        './company-page/company-how-to-use-mypage/company-how-to-use-mypage.module'
      ).then((m) => m.CompanyHowToUseMypageModule),
  },
  {
    path: 'client/how-to-use-mypage',
    loadChildren: () =>
      import(
        './company-page/company-how-to-use-mypage/company-how-to-use-mypage.module'
      ).then((m) => m.CompanyHowToUseMypageModule),
  },

  {
    path: 'en/client/job-question-answer-history/:jobCode',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-question-answer-history/company-job-question-answer-history.module'
      ).then((m) => m.CompanyJobQuestionAnswerHistoryModule),
  },
  {
    path: 'client/job-question-answer-history/:jobCode',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-job-question-answer-history/company-job-question-answer-history.module'
      ).then((m) => m.CompanyJobQuestionAnswerHistoryModule),
  },
  {
    path: 'en/client/scout-message-content/:staffId/:jobId/:companyId/:scoutId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-content/company-scout-message-content.module'
      ).then((m) => m.CompanyScoutMessageContentModule),
  },
  {
    path: 'client/scout-message-content/:staffId/:jobId/:companyId/:scoutId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-content/company-scout-message-content.module'
      ).then((m) => m.CompanyScoutMessageContentModule),
  },
  {
    path: 'en/client/scout-message-history/:staffId/:jobId/:companyId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-history/company-scout-message-history.module'
      ).then((m) => m.CompanyScoutMessageHistoryModule),
  },
  {
    path: 'client/scout-message-history/:staffId/:jobId/:companyId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-history/company-scout-message-history.module'
      ).then((m) => m.CompanyScoutMessageHistoryModule),
  },
  {
    path: 'en/client/scout-message-history/:staffId/:jobId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-history/company-scout-message-history.module'
      ).then((m) => m.CompanyScoutMessageHistoryModule),
  },
  {
    path: 'client/scout-message-history/:staffId/:jobId',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-message-history/company-scout-message-history.module'
      ).then((m) => m.CompanyScoutMessageHistoryModule),
  },

  {
    path: 'en/client/applicant-details',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-applicant-details/company-applicant-details.module'
      ).then((m) => m.CompanyApplicantDetailsModule),
  },
  {
    path: 'client/applicant-details',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-applicant-details/company-applicant-details.module'
      ).then((m) => m.CompanyApplicantDetailsModule),
  },
 
  {
    path: 'en/client/scout-step2',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-step2/company-scout-step2.module'
      ).then((m) => m.CompanyScoutStep2Module),
  },
  {
    path: 'client/scout-step2',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-scout-step2/company-scout-step2.module'
      ).then((m) => m.CompanyScoutStep2Module),
  },
  {
    path: 'en/client/scout-step3',
    loadChildren: () =>
      import(
        './company-page/company-scout-step3/company-scout-step3.module'
      ).then((m) => m.CompanyScoutStep3Module),
  },
  {
    path: 'client/scout-step3',
    loadChildren: () =>
      import(
        './company-page/company-scout-step3/company-scout-step3.module'
      ).then((m) => m.CompanyScoutStep3Module),
  },
  {
    path: 'en/client/send-scout-mail/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-send-scout-mail/company-send-scout-mail.module'
      ).then((m) => m.CompanySendScoutMailModule),
  },
  {
    path: 'client/send-scout-mail/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-send-scout-mail/company-send-scout-mail.module'
      ).then((m) => m.CompanySendScoutMailModule),
  },


  {
    path: 'en/client/withdraw',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./company-page/company-withdraw/company-withdraw.module').then(
        (m) => m.CompanyWithdrawModule
      ),
  },
  {
    path: 'en/client/user-guide',
    loadChildren: () =>
      import(
        './company-page/company-user-guide/company-user-guide.module'
      ).then((m) => m.CompanyUserGuideModule),
  },
  {
    path: 'client/user-guide',
    loadChildren: () =>
      import(
        './company-page/company-user-guide/company-user-guide.module'
      ).then((m) => m.CompanyUserGuideModule),
  },

  {
    path: 'client/error-report',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-error-report/company-error-report.module'
      ).then((m) => m.CompanyErrorReportModule),
  },
  {
    path: 'en/client/error-report',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './company-page/company-error-report/company-error-report.module'
      ).then((m) => m.CompanyErrorReportModule),
  },
  {
    path: 'jp/client-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './company-page/company-forgot-password/company-forgot-password.module'
      ).then((m) => m.CompanyForgotPasswordModule),
  },
  {
    path: 'en/client-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './company-page/company-forgot-password/company-forgot-password.module'
      ).then((m) => m.CompanyForgotPasswordModule),
  },
  {
    path: 'client-forgot-password/:id/:code',
    loadChildren: () =>
      import(
        './company-page/company-forgot-password/company-forgot-password.module'
      ).then((m) => m.CompanyForgotPasswordModule),
  },
  {
    path: 'client/semina200828',
    loadChildren: () =>
      import('./company-page/hr-semina1/hr-semina1.module').then(
        (m) => m.HrSemina1Module
      ),
  },
  {
    path: 'client/semina200925',
    loadChildren: () =>
      import('./company-page/hr-semina2/hr-semina2.module').then(
        (m) => m.HrSemina2Module
      ),
  },
  {
    path: 'client/semina201127',
    loadChildren: () =>
      import('./company-page/hr-semina3/hr-semina3.module').then(
        (m) => m.HrSemina3Module
      ),
  },
  {
    path: 'client/semina201217',
    loadChildren: () =>
      import('./company-page/semina201217/semina201217.module').then(
        (m) => m.Semina201217Module
      ),
  },
  {
    path: 'client/semina210121',
    loadChildren: () =>
      import('./company-page/semina210121/semina210121.module').then(
        (m) => m.Semina210121Module
      ),
  },
  {
    path: 'client/whitepaper',
    loadChildren: () =>
      import('./company-page/whitepaper/whitepaper.module').then(
        (m) => m.WhitepaperModule
      ),
  },
  {
    path: 'client/posting',
    loadChildren: () =>
      import('./company-page/posting-guideline/posting-guideline.module').then(
        (m) => m.PostingGuidelineModule
      ),
  },


  {
    path: 'en/client/translator',
    loadChildren: () =>
      import(
        './company-page/company-translator/company-translator.module'
      ).then((m) => m.CompanyTranslatorModule),
  },
  {
    path: 'client/semina200930',
    loadChildren: () =>
      import('./company-page/semina200930/semina200930.module').then(
        (m) => m.Semina200930Module
      ),
  },
  {
    path: 'en/client/semina200930',
    loadChildren: () =>
      import('./company-page/semina200930/semina200930.module').then(
        (m) => m.Semina200930Module
      ),
  },
  {
    path: 'client/translator-ja',
    loadChildren: () =>
      import(
        './company-page/company-translator-ja/company-translator-ja.module'
      ).then((m) => m.CompanyTranslatorJaModule),
  },
  {
    path: 'en/client/translator-ja',
    loadChildren: () =>
      import(
        './company-page/company-translator-ja/company-translator-ja.module'
      ).then((m) => m.CompanyTranslatorJaModule),
  },
  {
    path: 'client/interp_List',
    loadChildren: () =>
      import(
        './company-page/company-interp-list/company-interp-list.module'
      ).then((m) => m.CompanyInterpListModule),
  },
  {
    path: 'en/client/interp_List',
    loadChildren: () =>
      import(
        './company-page/company-interp-list/company-interp-list.module'
      ).then((m) => m.CompanyInterpListModule),
  },

  {
    path: 'client/semina200910',
    loadChildren: () =>
      import('./company-page/semina200910/semina200910.module').then(
        (m) => m.Semina200910Module
      ),
  },
  {
    path: 'en/client/interp_List',
    loadChildren: () =>
      import('./company-page/semina200910/semina200910.module').then(
        (m) => m.Semina200910Module
      ),
  },
  {
    path: 'company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
  {
    path: 'en/company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
  {
    path: 'kr/company-profile',
    loadChildren: () =>
      import('./staff-page/company-profile/company-profile.module').then(
        (m) => m.CompanyProfileModule
      ),
  },
];

@NgModule({
  imports: [
    //BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
